// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../img/bg/testimonial-bg.jpg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("../img/bg/call-to-action-bg.jpg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("../img/bg/inner-page-title-bg.jpg", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Montserrat:ital,wght@0,100;0,200;0,300;0,400;0,500;0,600;0,700;0,800;0,900;1,100;1,200;1,300;1,400;1,500;1,600;1,700;1,800;1,900&display=swap);"]);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/*========================================================================

	Template Name: Bootstrap 5 Multipurpose Business Website Template
	Author: Rainbow Design

========================================================================*/

/*----------------------------------

	Table of contents
	
	01. Common
	02. Header
	03. Slider
	04. Feature area
	05. Counter area
	06. Services
	07. Testimonials
	08. Team
	09. Call to action
	10. Blog
	11. Footer
	12. Inner page title
	13. Portfolio
	14. Contact form
		
----------------------------------*/

/* Theme Font Use */
/* font-family: 'Montserrat', sans-serif; */



/* ===================================
	01. Common
=================================== */
::selection {
	background-color: #00bcd4;
	color: #fff;
}

::-moz-selection {
	background-color: #00bcd4;
	color: #fff;
}

img {
	max-width: 100%;
}

body {
	font-size: 16px;
	font-family: 'Montserrat', sans-serif;
	color: #252525;
	letter-spacing: 0.5px;
}

.theme-bg-light {
	background-color: #1D4DDC;
}

p {
	line-height: 24px;
	font-size: 14px;
	color: #6c757d;
	font-family: 'Montserrat', sans-serif;
}

h1,
h2,
h3,
h4,
h5,
h6 {
	margin: 0px;
	color: #202020;
	padding: 0px;
	line-height: 1.4;
	letter-spacing: 1px;
	font-family: 'Montserrat', sans-serif;
}

h1 {
	font-size: 60px;
	font-weight: 700;
}

h2 {
	font-size: 36px;
	font-weight: 700;
}

h3 {
	font-size: 26px;
	font-weight: 700;
}

h4 {
	font-size: 24px;
	font-weight: 700;
}

h5 {
	font-size: 18px;
	font-weight: 700;
}

h6 {
	font-size: 16px;
	font-weight: 700;
}

ul,
ol,
li {
	margin: 0px;
	padding: 0px;
	list-style: none;
}

a {
	text-decoration: none;
	cursor: pointer;
}

a:hover {
	text-decoration: none;
}

/* --- Top Scroll --- */
.scroll-top {
	display: none;
	position: fixed;
	bottom: 2px;
	text-align: center;
	right: 2%;
	width: 40px;
	height: 40px;
	line-height: 40px;
	font-size: 12px;
	color: #fff;
	background-color: #00bcd4;
	text-decoration: none;
	border-radius: 100%;
	z-index: 9999;
}

.scroll-top:hover {
	color: #fff !important;
	text-decoration: none;
	background-color: #018fa2;
}

/* --- Buttons --- */
.btn-style-1 {
	background-color: #00bcd4;
	color: #fff;
	border: 0;
	border-radius: 4px;
	padding: 12px 20px;
	font-size: 14px;
	text-transform: uppercase;
	font-weight: 600;
	line-height: 22px;
	text-decoration: none;
	display: inline-block;
	transition: all 0.3s ease-in-out;
}

.btn-style-1:hover {
	background-color: #018fa2;
	color: #fff;
	text-decoration: none;
}

.btn-style-2 {
	color: #fff;
	background-color: #202020;
	border-radius: 4px;
	padding: 12px 20px;
	font-size: 14px;
	font-weight: 600;
	text-transform: uppercase;
	line-height: 22px;
	text-decoration: none;
	display: inline-block;
	transition: all 0.3s ease-in-out;
}

.btn-style-2:hover {
	background-color: #00bcd4;
	color: #fff;
	text-decoration: none;
}

/* --- Loading --- */
#preloader {
	position: fixed;
	left: 0;
	top: 0;
	z-index: 99999;
	width: 100%;
	text-align: center;
	height: 100%;
	vertical-align: middle;
	height: 100%;
	overflow: visible;
	background-color: #fff;
}

#preloader .spinner-grow {
	top: 50%;
	position: relative;
}

/* --- section title --- */
.section-title h2 {
	font-weight: 600;
	font-size: 34px;
	text-transform: uppercase;
	position: relative;
	color: #333;
}

.section-title h2 span {
	position: relative;
	padding-bottom: 16px;
	margin-bottom: 45px;
	display: inline-block;
}

.section-title h2 span:after {
	position: absolute;
	content: "";
	width: 30px;
	height: 1px;
	left: 0px;
	right: 0px;
	margin: auto;
	bottom: 0;
	background-color: #00bcd4;
}

.section-title h2 span:before {
	position: absolute;
	content: "";
	width: 50px;
	height: 1px;
	left: 0px;
	right: 0px;
	margin: auto;
	bottom: 3px;
	background-color: #00bcd4;
}


/* ===================================
	NEW CARD CLUB 
=================================== */
.text-truncate-3 {
    display: -webkit-box;
    -webkit-line-clamp: 3;
    -webkit-box-orient: vertical;
    overflow: hidden;
    text-overflow: ellipsis;
}
/* ===================================
	04. Feature area
=================================== */
.feature-area {
    background-color: var(--background-color);
    color: var(--text-color);
    transition: background-color 0.3s ease, color 0.3s ease;
}

.feature-area h1{
    color: var(--text-color);
    transition: background-color 0.3s ease, color 0.3s ease;
}
.feature-area h2{
    color: var(--text-color);
    transition: background-color 0.3s ease, color 0.3s ease;
}

.feature-area p{
    color: var(--text-color);
    transition: background-color 0.3s ease, color 0.3s ease;
}


.card {
	background-color: #cbd9ff;
	position: relative;
	border-radius: 6px;
	padding: 20px 20px;
	border: 2px solid #000000;
	text-align: center;
	z-index: 0;
	font-weight: 500; /* Épaissir le texte sans le rendre gras */
	transition: all 0.3s ease-in-out;
  }
  
  

.card:after {
	width: 0px;
	height: 0px;
	content: "";
	position: absolute;
	top: 50%;
	left: 0px;
	right: 0px;
	margin: auto;
	background-color: #00e1ff;
	transform: translateY(-50%);
	border-radius: 0%;
	opacity: 0.2;
	z-index: -1;
	transition: all 0.5s ease-in-out;
}

.card:hover:after {
	width: 100%;
	height: 100%;
}

.card:hover {
	border: 2px solid #00cee9;
}

.card .icon {
	color: #333;
	margin-bottom: 10px;
	font-size: 35px;
	transition: all 0.3s ease-in-out;
}

.card:hover .icon {
	color: #00bcd4;
}

.card h4 {
	margin-bottom: 2px;
}





/* ===================================
	03. Slider
=================================== */
.slider .carousel-item:after {
	position: absolute;
	content: "";
	background-color: rgba(0, 0, 0, 0.5);
	width: 100%;
	height: 100%;
	left: 0px;
	top: 0px;
	z-index: 1;
}

.slider h2 {
	font-size: 40px;
	color: #202020;
	margin-bottom: 10px;
	font-weight: 600;
	text-decoration: underline;
}

.slider .carousel-caption {
	top: 50%;
	bottom: auto;
	padding-top: 0px;
	left: 0px;
	right: 0px;
	padding-bottom: 0px;
	transform: translateY(-50%);
	z-index: 2;
}

.slider .carousel-caption .white-box {
	background-color: rgba(255, 255, 255, 0.7);
	margin: auto;
	color: #333;
	position: relative;
	border-radius: 6px;
	padding: 20px 20px;
	border: 2px solid #00bcd4;
}

.slider .carousel-caption p a {
	border-radius: 4px;
	background-color: #00bcd4;
	border: 0px;
	color: #fff;
	text-transform: uppercase;
	font-size: 14px;
	font-weight: 700;
	padding: 8px 24px;
}

/* ===================================
	04. Feature area
=================================== */
.feature-box {
	background-color: #dffbff;
	position: relative;
	border-radius: 6px;
	padding: 20px 20px;
	text-align: center;
	border: 2px solid rgba(0, 0, 0, 0.1);
	z-index: 0;
	transition: all 0.3s ease-in-out;
}

.feature-box:after {
	width: 0px;
	height: 0px;
	content: "";
	position: absolute;
	top: 50%;
	left: 0px;
	right: 0px;
	margin: auto;
	background-color: #00e1ff;
	transform: translateY(-50%);
	border-radius: 0%;
	opacity: 0.2;
	z-index: -1;
	transition: all 0.5s ease-in-out;
}

.feature-box:hover:after {
	width: 100%;
	height: 100%;
}

.feature-box:hover {
	border: 2px solid #00cee9;
}

.feature-box .icon {
	color: #333;
	margin-bottom: 10px;
	font-size: 35px;
	transition: all 0.3s ease-in-out;
}

.feature-box:hover .icon {
	color: #00bcd4;
}

.feature-box h4 {
	margin-bottom: 2px;
}

/* ===================================
	05. Counter area
=================================== */
.single-counter-box {
	position: relative;
	text-align: center;
}

.single-counter-box .icon-wrap {
	width: 90px;
	height: 90px;
	text-align: center;
	line-height: 90px;
	margin: auto auto 20px auto;
	color: #fff;
	border: 2px solid rgba(0, 0, 0, 0.1);
	border-radius: 6px;
	background-color: #00bcd4;
	font-size: 24px;
	position: relative;
	transition: all 0.3s ease-in-out;
}

.single-counter-box .text-wrap .counter-info-text span {
	color: #202020;
	font-weight: 600;
	font-size: 50px;
	line-height: 50px;
	margin-bottom: 10px;
	display: inline-block;
}

.single-counter-box .text-wrap h4 {
	color: #6c757d;
	font-weight: 400;
	font-size: 16px;
	white-space: nowrap;
}

/* ===================================
	06. Services
=================================== */
.services-item {
	background-color: rgba(255, 255, 255, 1);
	position: relative;
	border-radius: 6px;
	padding: 20px 20px;
	border: 2px solid rgba(0, 0, 0, 0.1);
	z-index: 0;
	transition: all 0.3s ease-in-out;
}

.services-item .icon-box {
	color: #00bcd4;
	margin-bottom: 20px;
	line-height: 20px;
	font-size: 40px;
	transition: all 0.3s ease-in-out;
}

.services-item h4 {
	margin-bottom: 20px;
	transition: all 0.3s ease-in-out;
}

.services-item p {
	transition: all 0.3s ease-in-out;
}

.services-item a {
	position: absolute;
	top: 20px;
	right: 20px;
	display: inline-block;
	width: 40px;
	height: 40px;
	font-size: 16px;
	text-align: center;
	line-height: 40px;
	background-color: #f5f5f5;
	color: #202020;
	border-radius: 4px;
	box-shadow: 0 8px 20px hsla(0, 0%, 0%, 0.13);
}

.services-item:hover {
	background-color: #00bcd4;
	border: 2px solid #00bcd4;
}

.services-item:hover .icon-box,
.services-item:hover h4,
.services-item:hover p {
	color: #fff;
}

/* service link sidebar */
.service-link {
	background-color: #00bcd4;
	border-radius: 6px;
	padding: 30px;
	margin-bottom: 0px;
}

.service-link li {
	border-bottom: 1px solid rgba(255, 255, 255, 0.2);
	margin-bottom: 12px;
	padding-bottom: 12px;
}

.service-link li a {
	text-decoration: none;
	color: #fff;
	padding-left: 16px;
	font-size: 14px;
	display: inline-block;
	position: relative;
	transition: all 0.3s ease-in-out;
}

.service-link li:last-child {
	border-bottom: 0px;
	margin-bottom: 0px;
}

.service-link li:last-child {
	padding-bottom: 0px;
}

.service-link li a:hover {
	color: #333;
}

.service-link li a:before {
	display: inline-block;
	width: 0;
	height: 0;
	left: 0px;
	top: 50%;
	position: absolute;
	margin-left: 0;
	content: "";
	border-top: .3em solid transparent;
	border-bottom: .3em solid transparent;
	border-right: 0;
	border-left: .3em solid;
	transform: translateY(-50%);
}

/* download brochure */
.download-brochure a {
	background-color: #00bcd4;
	text-decoration: none;
	border-radius: 6px;
	display: inline-block;
	overflow: hidden;
	color: #fff;
	width: 100%;
	font-size: 14px;
}

.download-brochure a i {
	background-color: #018fa2;
	padding: 20px 16px;
	margin-right: 10px;
}

/* service contant img */
.service-contant-img img {
	border: 2px solid rgba(0, 0, 0, 0.1);
	border-radius: 6px;
	padding: 6px;
}

/* blockquote */
.service-detail-contant blockquote {
	border: 0px;
	background-color: #202020;
	padding: 30px;
	border-radius: 6px;
	margin-bottom: 0px;
}

.service-detail-contant blockquote p {
	color: #fff;
	font-style: italic;
	font-size: 16px;
	line-height: 28px;
}

.service-detail-contant blockquote .blockquote-footer {
	margin-top: 10px;
	color: #00bcd4;
	font-size: 12px;
}

/* ===================================
	07. Testimonials
=================================== */
.testimonial-area {
	background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
	background-size: cover;
	background-position: center top;
	position: relative;
}

.testimonial-area:after {
	position: absolute;
	content: "";
	background-color: rgba(0, 0, 0, 0.7);
	width: 100%;
	height: 100%;
	left: 0px;
	top: 0px;
}

.testimonial-item p {
	text-align: center;
	color: #fff;
	font-style: italic;
	padding-top: 35px;
	margin-bottom: 0px;
	border-top: 2px solid rgba(255, 255, 255, 0.2);
}

.testimonial-item .position {
	color: #00bcd4;
	text-transform: uppercase;
	font-size: 12px;
	font-weight: 600;
	padding-bottom: 6px;
}

.testimonial-item .testimonial-client-img {
	color: #fff;
	border-radius: 50px;
	padding: 0px;
	height: 100px;
	width: 100px;
	margin: 35px auto auto auto;
	display: inline-block;
}

.testimonial-item .testimonial-client-img img {
	border: 2px solid rgba(0, 0, 0, 0.1);
	border-radius: 6px;
}

.testimonial-item .testimonial-line {
	width: 100%;
	text-align: center;
	position: relative;
}

.testimonial-item .testimonial-line:after {
	background-color: rgba(255, 255, 255, 0.2);
	content: "";
	display: block;
	height: 2px;
	left: 0;
	margin-top: 17px;
	position: absolute;
	right: 0;
	top: 50%;
	transform: translateY(-50%);
	width: 100%;
	z-index: -1;
}

.testimonial-item .testimonial-client {
	width: 100%;
	margin: 10px 0 0 0px;
}

.testimonial-item .testimonial-client h6 {
	margin-bottom: 0px;
	color: #fff;
	text-transform: uppercase;
}

.testimonial-item .testimonial-client p {
	font-size: 13px;
	font-weight: 500;
	color: #fff;
	margin-bottom: 0px;
}

.testimonial-item .testimonial-info {
	margin: 0 auto;
	overflow: hidden;
	text-align: center;
}

.testimonial-carousel .owl-nav button {
	width: 40px;
	height: 40px;
	font-size: 16px;
	text-align: center;
	color: #202020 !important;
	border-radius: 4px;
	margin: 15px 4px 0 4px !important;
	background-color: #f5f5f5 !important;
	transition: all 0.3s ease-in-out;
}

.testimonial-carousel .owl-nav button:hover {
	background-color: #00bcd4 !important;
	color: #fff !important;
}

/* ===================================
	08. Team
=================================== */
.team-item {
	position: relative;
	border-radius: 10px;
	border: 2px solid rgba(0, 0, 0, 0.1);
	overflow: hidden;
	transition: all 0.3s ease-in-out;
}

.team-item:hover {
	border: 2px solid #00bcd4;
}

.team-item .team-info {
	padding: 10px 50px 10px 15px;
	position: absolute;
	left: 0px;
	bottom: 0px;
	border-radius: 0px 6px 6px 0px;
	display: inline-block;
	background-color: #202020;
	clip-path: polygon(0% 0%, 100% 0%, 80% 100%, 0% 100%);
	transition: all 0.3s ease-in-out;
}

.team-item:hover .team-info {
	background-color: #00bcd4;
}

.team-item .team-info h5 a {
	color: #fff;
	font-size: 16px;
	display: inline-block;
	margin-bottom: 4px;
	text-transform: uppercase;
}

.team-item .team-info h6 {
	color: #fff;
	font-size: 11px;
	text-transform: uppercase;
	font-weight: 600;
}

/* Media Query pour les écrans de moins de 768px */

@media (max-width: 768px) {
	.team-item .team-info h5 a {

		font-size: 14px;
		/* Réduit la taille de la police à 14px sur les petits écrans */
	}

	.team-item .team-info h6 {

		font-size: 9px;
		/* Réduit la taille de la police à 14px sur les petits écrans */
	}
}

/* Media Query pour les écrans de moins de 576px */
@media (max-width: 576px) {
	.team-item .team-info h5 a {

		font-size: 12px;
		/* Réduit encore la taille de la police à 12px sur les très petits écrans */
	}

	.team-item .team-info h6 {

		font-size: 7px;
		/* Réduit la taille de la police à 14px sur les petits écrans */
	}
}

.team-social {
	position: absolute;
	top: 0px;
	right: 0px;
	background-color: #00bcd4;
}

.team-social li a {
	width: 40px;
	height: 40px;
	text-align: center;
	line-height: 40px;
	color: #fff;
	border-bottom: 1px solid rgba(255, 255, 255, 0.2);
	background-color: #00bcd4;
	display: inline-block;
	font-size: 14px;
	transition: all 0.3s ease-in-out;
}

.team-social li:last-child a {
	border-bottom: 0px;
}

.team-social li a:hover {
	background-color: #018fa2;
}

/* ===================================
	08.5 Carte membre
=================================== */
.RolePresident{
	clip-path: polygon(10% 0%, 90% 0%, 80% 100%, 20% 100%);
	background-color: #00bcd4;
	font-size: 12px; /* Ajuste la taille de la police ici */
}

.RoleMembre{
	clip-path: polygon(10% 0%, 90% 0%, 80% 100%, 20% 100%);
	background-color: #00d4b1;
	font-size: 12px; /* Ajuste la taille de la police ici */
}


/* ===================================
	09. Call to action
=================================== */
.call-to-action-area {
	background-image: url(${___CSS_LOADER_URL_REPLACEMENT_1___});
	background-size: cover;
	background-position: center top;
	position: relative;
	text-align: center;
	z-index: 0;
}

.call-to-action-area:after {
	position: absolute;
	content: "";
	background-color: rgba(0, 0, 0, 0.7);
	width: 100%;
	height: 100%;
	left: 0px;
	top: 0px;
	z-index: -1;
}

.cta-content h3 {
	font-size: 18px;
	color: #00bcd4;
	font-weight: 400;
	margin-bottom: 20px;
}

.call-to-action-area h2 {
	color: #fff;
	font-weight: 700;
	font-size: 40px;
	line-height: 44px;
	margin-bottom: 20px;
}

.call-to-action-area h2 a {
	color: #fff;
	text-decoration: underline;
}

.call-to-action-area p {
	color: #fff;
	line-height: 28px;
}

.video-popup {
	position: relative;
	display: inline-block;
	width: 80px;
	height: 80px;
	line-height: 80px;
	color: #fff;
	font-size: 24px;
	margin-bottom: 30px;
	border-radius: 100%;
	background-color: #00bcd4;
}

.video-popup:before {
	position: absolute;
	content: '';
	width: 100%;
	height: 100%;
	background: #00bcd4;
	border-radius: 100%;
	top: 0;
	animation-fill-mode: both;
	animation: witr_squares 1.5s ease-in-out infinite;
	left: 0;
	right: 0;
	bottom: 0;
	z-index: 0;
}

.video-popup:after {
	position: absolute;
	content: '';
	width: 90px;
	height: 90px;
	border: 2px solid #00bcd4;
	border-radius: 100%;
	top: -5px;
	left: -5px;
	right: 0;
	bottom: 0;
	z-index: 0;
}

.video-popup i {
	z-index: 2;
	position: relative;
}

.video-popup:hover {
	color: #fff;
}

/* witr_squares_ */
@keyframes witr_squares {
	0% {
		transform: scale(1);
		opacity: 0
	}

	20% {
		transform: scale(1.24);
		opacity: 1
	}

	100% {
		transform: scale(2.1);
		opacity: 0
	}
}

/* ===================================
	10. Blog
=================================== */
.blog-item {
	position: relative;
	border-radius: 6px;
	border: 2px solid rgba(0, 0, 0, 0.1);
	overflow: hidden;
	transition: all 0.3s ease-in-out;
}

.blog-item:hover {
	border: 2px solid #00bcd4;
}

.blog-item .blog-content-area {
	padding: 20px;
}

.blog-item .blog-meta {
	margin-bottom: 10px;
}

.blog-item .blog-meta li {
	position: relative;
	font-size: 12px;
	color: #202020;
	margin-right: 16px !important;
}

.blog-item .blog-meta li a {
	color: #202020;
	transition: all 0.3s ease-in-out;
}

.blog-item .blog-meta li a:hover {
	color: #00bcd4;
}

.blog-item .blog-meta li:after {
	position: absolute;
	content: "/";
	top: 50%;
	font-size: 10px;
	right: -12px;
	transform: translateY(-50%);
}

.blog-item .blog-meta li:last-child {
	margin-right: 0px !important;
}

.blog-item .blog-meta li:last-child:after {
	display: none;
}

.blog-item h4 {
	line-height: 24px;
	margin-bottom: 10px;
}

.blog-item h4 a {
	color: #202020;
	font-size: 18px;
	transition: all 0.3s ease-in-out;
}

.blog-item h4 a:hover {
	color: #00bcd4;
}

.blog-item .blog-thumb {
	position: relative;
}

.blog-item .blog-thumb:after {
	position: absolute;
	content: "";
	width: 0;
	height: 0;
	background-color: rgba(0, 0, 0, 0.3);
	top: 0px;
	opacity: 0;
	left: 0px;
	right: 0px;
	margin: auto;
	z-index: 0;
	transition: all 0.3s ease-in-out;
}

.blog-item:hover .blog-thumb:after {
	width: 100%;
	height: 100%;
	opacity: 1;
}

.blog-item .blog-thumb a {
	position: absolute;
	top: 20px;
	right: 20px;
	display: inline-block;
	width: 40px;
	height: 40px;
	font-size: 16px;
	text-align: center;
	line-height: 40px;
	background-color: #f5f5f5;
	color: #202020;
	border-radius: 4px;
	box-shadow: 0 8px 20px hsla(0, 0%, 0%, 0.13);
	z-index: 1;
}

/* singal post img */
.singal-blog-post {
	border: 2px solid rgba(0, 0, 0, 0.1);
	border-radius: 6px;
	overflow: hidden;
}

/* blog meta */
.singal-blog-post .singal-blog-meta {
	margin-bottom: 10px;
}

.singal-blog-post .singal-blog-meta li {
	position: relative;
	font-size: 12px;
	color: #202020;
	padding-bottom: 0px;
	margin-right: 16px !important;
}

.singal-blog-post .singal-blog-meta li a {
	color: #202020;
	transition: all 0.3s ease-in-out;
}

.singal-blog-post .singal-blog-meta li a:hover {
	color: #00bcd4;
}

.singal-blog-post .singal-blog-meta li:after {
	position: absolute;
	content: "/";
	top: 50%;
	font-size: 10px;
	right: -12px;
	transform: translateY(-50%);
}

.singal-blog-post .singal-blog-meta li:last-child {
	margin-right: 0px !important;
}

.singal-blog-post .singal-blog-meta li:last-child:after {
	display: none;
}

/* blockquote */
.singal-blog-post blockquote {
	border: 0px;
	padding: 10px 30px;
	border-left: 2px solid #00bcd4;
	margin-bottom: 20px;
}

.singal-blog-post blockquote p {
	color: #333;
	font-style: italic;
	font-size: 16px;
	line-height: 28px;
}

.singal-blog-post blockquote .blockquote-footer {
	margin-top: 10px;
	color: #00bcd4;
	font-size: 12px;
}

.singal-blog-post ul li i {
	color: #00bcd4;
	padding-right: 8px;
}

.singal-blog-post ul li {
	color: #6c757d;
	font-size: 14px;
	padding-bottom: 14px;
}

.singal-blog-post ul li:last-child {
	padding-bottom: 0px;
}

/* social block */
.social-block {
	border-top: 1px solid rgba(0, 0, 0, 0.1);
	padding: 20px 0 0px 0;
}

.singal-blog-post .tags-post a {
	font-size: 12px;
	color: #6c757d;
	text-decoration: none;
	padding: 4px 12px;
	position: relative;
	transition: all 0.3s ease-in-out;
}

.singal-blog-post .tags-post a:after {
	position: absolute;
	content: "/";
	top: 50%;
	font-size: 10px;
	transform: translateY(-50%);
	right: -2px;
}

.singal-blog-post .tags-post a:first-child {
	padding-left: 0px;
}

.singal-blog-post .tags-post a:last-child {
	padding-right: 0px;
}

.singal-blog-post .tags-post a:last-child:after {
	display: none;
}

.singal-blog-post .tags-post a:hover {
	color: #00bcd4;
}

.singal-blog-post .share-social a {
	font-size: 12px;
	background-color: #6c757d;
	color: #fff;
	text-decoration: none;
	width: 30px;
	height: 30px;
	line-height: 30px;
	text-align: center;
	display: inline-block;
	border-radius: 100%;
	transition: all 0.3s ease-in-out;
}

.singal-blog-post .share-social a:hover {
	background-color: #00bcd4;
}

/* comments box */
.comments-box {
	width: 100%;
	padding-bottom: 30px;
	display: inline-block;
	margin-bottom: 30px;
	border-bottom: 1px solid rgba(0, 0, 0, 0.1);
}

.comments-box:last-child {
	padding-bottom: 0px;
	margin-bottom: 0px;
	border-bottom: 0px;
}

.comments-box .img-wrapper {
	float: left;
	width: 100px;
}

.comments-box .img-wrapper img {
	border: 3px solid #fff;
	border-radius: 100%;
	transition: all 0.3s ease-in-out;
}

.comments-box .text-wrapper {
	float: left;
	width: calc(100% - 100px);
	padding-left: 30px;
}

.author-detail {
	margin-bottom: 10px;
}

.author-detail .author-name {
	font-size: 18px;
	color: #00bcd4;
}

.author-detail .publish-date {
	font-size: 12px;
	margin-left: 8px;
	color: #999;
}

.author-content a {
	color: #00bcd4;
	font-size: 12px;
	text-transform: uppercase;
}

.author-content a i {
	color: #00bcd4;
	font-size: 14px;
	margin-left: 5px;
}

.comments-box:hover .img-wrapper img {
	border: 3px solid #00bcd4;
}

/* comments form */
.comments-form input {
	background-color: #fff;
	border: 1px solid rgba(0, 0, 0, 0.1);
	border-radius: 6px;
	font-size: 14px;
	height: 50px;
}

.comments-form textarea {
	background-color: #fff;
	border: 1px solid rgba(0, 0, 0, 0.1);
	border-radius: 6px;
	font-size: 14px;
}

.comments-form .form-control:focus {
	box-shadow: none;
	border: 2px solid #00bcd4;
}

/* ===================================
	11. Footer
=================================== */
.footer {
	background-color: #202020;
}

.footer-about {
	text-align: center;
}

/* footer social */
.footer-social a {
	width: 40px;
	height: 40px;
	line-height: 40px;
	text-align: center;
	border-radius: 100%;
	color: #fff;
	background-color: #2d2d2d;
	display: inline-block;
	transition: all 0.3s ease-in-out;
}

.footer-social a:hover {
	background-color: #00bcd4;
}

/* footer contact */
.footer-contact {
	border-top: 1px solid rgba(255, 255, 255, 0.1);
	padding-top: 30px;
	margin-top: 30px;
	margin-bottom: 15px;
}

.footer-contact li {
	margin: 0px 30px 0px 0px !important;
}

.footer-contact li:last-child {
	margin: 0px 0px 0px 0px !important;
}

.footer-contact li,
.footer-contact li a {
	color: #6c757d;
	font-size: 14px;
	transition: all 0.3s ease-in-out;
}

.footer-contact li {
	padding-bottom: 15px;
}

.footer-contact li i {
	padding-right: 6px;
}

.footer-contact li a:hover {
	color: #00bcd4;
}

/* footer bottom */
.footer-bottom {
	border-top: 1px solid rgba(255, 255, 255, 0.1);
	padding-top: 30px;
	padding-bottom: 20px;
	background-color: #181818;
}

/* footer link */
.footer-link li {
	margin: 0px 20px 0px 0px !important;
}

.footer-link li:last-child {
	margin: 0px 0px 0px 0px !important;
}

.footer-link li a {
	color: #6c757d;
	font-size: 14px;
	display: inline-block;
	padding-bottom: 10px;
	transition: all 0.3s ease-in-out;
}

.footer-link li a:hover {
	color: #00bcd4;
}

/* footer copyright */
.footer-copyright {
	color: #6c757d;
	font-size: 14px;
	margin-bottom: 10px;
}

/* ===================================
	12. Inner page title
=================================== */
.inner-page-title-area {
	background-image: url(${___CSS_LOADER_URL_REPLACEMENT_2___});
	background-repeat: no-repeat;
	background-position: center top;
	text-align: center;
	background-size: cover;
	padding: 220px 0px;
	position: relative;
	z-index: 0;
}

.inner-page-title-area:after {
	background-color: rgba(0, 0, 0, 0.6);
	position: absolute;
	width: 100%;
	height: 100%;
	content: "";
	top: 0px;
	left: 0px;
	z-index: -1;
}

.inner-page-title-area h1 {
	font-weight: 600;
	font-size: 36px;
	color: #fff;
	margin-top: 20px;
	line-height: 24px;
}

.inner-page-title-area h1 span {
	position: relative;
}

.inner-page-title-area h1 span:after {
	position: absolute;
	content: "";
	width: 1px;
	height: 94%;
	background-color: #00bcd4;
	top: 50%;
	left: -25px;
	transform: translateY(-50%);
}

.inner-page-title-area h1 span:before {
	position: absolute;
	content: "";
	width: 1px;
	height: 94%;
	background-color: #00bcd4;
	top: 50%;
	right: -25px;
	transform: translateY(-50%);
}

.inner-page-title-area .breadcrumb {
	margin: auto;
	text-align: center;
	padding: 0px;
	display: inline-block;
	background-color: transparent;
}

.inner-page-title-area .breadcrumb li {
	float: none;
	color: #fff;
	display: inline-block;
}

.inner-page-title-area .breadcrumb li a {
	color: #00bcd4;
}

.inner-page-title-area .breadcrumb-item+.breadcrumb-item:before {
	color: #fff;
}

/* ===================================
	13. Portfolio
=================================== */
#portfoliolist .portfolio {
	-webkit-box-sizing: border-box;
	-moz-box-sizing: border-box;
	-o-box-sizing: border-box;
	display: none;
}

.filter1 {
	border: 1px solid #eee;
	border-radius: 30px;
	padding: 10px;
}

.filter1 li {
	margin-right: 0px !important;
}

.filter1 li span {
	cursor: pointer;
	padding: 8px 12px 8px 12px;
	display: inline-block;
	position: relative;
	font-size: 12px;
	font-weight: 400;
	color: #fff;
	background-color: #202020;
	border-radius: 30px;
	text-transform: uppercase;
	transition: all 0.3s ease-in-out;
}

.filter1 li span.active,
.filter1 li span:hover {
	color: #fff;
	background-color: #00bcd4;
}

.portfolio-box {
	margin-bottom: 30px;
	position: relative;
	border-radius: 6px;
	border-bottom: 2px solid rgba(0, 0, 0, 0.1);
	text-align: center;
	overflow: hidden;
}

.portfolio-box .portfolio-box-img {
	position: relative;
	overflow: hidden;
}

.portfolio-box .portfolio-box-img .hoverlay {
	height: 100%;
	left: 0;
	position: absolute;
	top: 0;
	width: 100%;
	background-color: rgba(0, 0, 0, 0);
	transition: all 0.5s ease-in-out;
}

.portfolio-box:hover .portfolio-box-img .hoverlay {
	background-color: rgba(0, 0, 0, 0.8);
}

.portfolio-box .readmore {
	color: #fff;
	font-size: 12px;
	position: absolute;
	right: 0px;
	left: 0px;
	background-color: #00bcd4;
	opacity: 0;
	margin: auto;
	top: 50%;
	width: 40px;
	height: 40px;
	text-align: center;
	border-radius: 100%;
	transform: translateY(-50%);
	line-height: 40px;
	transition: all 0.3s ease-in-out;
}

.portfolio-box:hover .readmore {
	opacity: 1;
}

.portfolio-box .hoverlay a:hover {
	color: #fff;
}

.portfolio-box h5 {
	color: #202020;
	font-size: 16px;
	font-weight: 600;
	padding: 20px 0px;
	transition: all 0.3s ease-in-out;
}

.portfolio-box:hover h5 {
	background-color: #00bcd4;
	color: #fff;
}

/* ===================================
	14. Contact form
=================================== */
/* contact form */
.contact-form input {
	background-color: #fff;
	border: 1px solid rgba(0, 0, 0, 0.1);
	border-radius: 6px;
	font-size: 14px;
	height: 50px;
}

.contact-form textarea {
	background-color: #fff;
	border: 1px solid rgba(0, 0, 0, 0.1);
	border-radius: 6px;
	font-size: 14px;
}

.contact-form .form-control:focus {
	box-shadow: none;
	border: 2px solid #00bcd4;
}

.help-block.with-errors ul {
	color: #721c24;
	background-color: #f8d7da;
	border-color: #f5c6cb;
	padding: 10px;
}

/* contact info */
.contact-info-item {
	margin-bottom: 20px;
	width: 100%;
	display: inline-block;
}

.contact-info-item:last-child {
	margin-bottom: 0px;
}

.contact-info-item .icon-box {
	width: 40px;
	float: left;
	margin-right: 5px;
}

.contact-info-item .icon-box i {
	color: #00bcd4;
	font-size: 18px;
}

.contact-info-item .text-info {
	width: 80%;
	float: left;
	margin-left: 5px;
}

.contact-info-item .text-info h6 {
	margin-bottom: 5px;
}

.contact-info-item .text-info p {
	margin-bottom: 0px;
}

.contact-info-item a {
	color: #6c757d;
	text-decoration: none;
}

.contact-info-item a:hover {
	color: #00bcd4;
}

/* map */
.map-box iframe {
	width: 100%;
	border: 0px;
	height: 270px;
}



/* Calendrier */
.rbc-calendar {
	background-color: #f8f9fa;
	border-radius: 8px;
	box-shadow: 0px 4px 10px rgba(0, 0, 0, 0.1);
  }
  
  .rbc-event {
	background-color: #007bff;
	color: white;
	border-radius: 4px;
	padding: 5px;
  }
  
  .rbc-toolbar button {
	background-color: #007bff;
	color: white;
	border-radius: 4px;
  }
  
  .rbc-toolbar button:hover {
	background-color: #0056b3;
  }
  
  .rbc-month-view, .rbc-time-view {
	border: none;
  }

  .rbc-event {
	font-size: 12px; /* Ajustez la taille selon vos besoins */
	white-space: nowrap; /* Empêche le texte de passer à la ligne */
	overflow: hidden; /* Masque le débordement */
	text-overflow: ellipsis; /* Ajoute des "..." pour indiquer qu'il y a plus de texte */
  }
  

  .faq-container {
	max-width: 800px;
	margin: 0 auto;
	padding: 20px;
	background-color: #f4f6f7; /* Couleur de fond claire pour un contraste agréable */
	border-radius: 10px;
  }
  
   /* FAQ */
  .faq-item {
	margin-bottom: 15px;
	border-radius: 6px;
	box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
	transition: all 0.3s ease-in-out;
  }
  
  .faq-question {
	background-color: #00bcd4;
	color: #fff;
	padding: 15px;
	font-size: 1.1rem;
	font-weight: 600;
	cursor: pointer;
	display: flex;
	justify-content: space-between;
	align-items: center;
	border-radius: 6px;
	transition: background-color 0.3s ease;
  }
  
  .faq-question:hover {
	background-color: #008c9e;
  }
  
  .faq-toggle-icon {
	font-size: 1.5rem;
  }
  
  .faq-answer {
	background-color: #e7f5f8;
	color: #333;
	padding: 15px;
	font-size: 1rem;
	line-height: 1.6;
	border-top: 1px solid #00bcd4;
	border-radius: 0 0 6px 6px;
  }
  
  .faq-question.active {
	background-color: #008c9e;
  }
  
  
  

 /* --------------------- Mode nuit --------------------- */

/* BOUTON DARK MODE */
.theme-switcher-floating {
	position: fixed;
	top: 2px; /* Décalage du haut */
	right: 2px; /* Décalage du bord droit */
	z-index: 9999; /* Pour qu'il soit toujours au-dessus des autres éléments */
	padding: 3px;
	border-radius: 5px;
  }
  
  .theme-switcher-floating .form-check {
	margin-bottom: 0;
  }
  
  @media (max-width: 768px) {
	.theme-switcher-floating {
	  top: 2px;
	  right: 2px;
	}
  }
  
  @media (min-width: 1200px) {
	.theme-switcher-floating {
	  top: 10px;
	  right: 10px;
	}
  }
  


/* Mode clair */
.light-mode {
	--background-color: #ffffff;
	--text-color: #000000;
	--navbar-text-color: #db1f1f;
  }
  
  /* Mode sombre */
  .dark-mode {
	--background-color: #555555;
	--text-color: #ffffff;
	--navbar-bg-color: #1481ee;
	--navbar-text-color: #ffffff;

  }
  
  /* Applique les variables de couleur */

.dark-mode .no-dark-mode {
    color: #000000 !important; /* Forcer la couleur en noir */
}

.dark-mode .ConstructionPopUp .no-dark-mode {
    color: #000000 !important; /* Forcer la couleur en noir */
}
  
/* Styles pour l'animation et les cartes personnalisées */
.protocol-card {
	border-radius: 10px;
	cursor: pointer;
	transition: transform 0.3s ease;
	background-color: #ffffff;
	box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
  }
  
  .protocol-card.active {
	transform: scale(1.02); /* Agrandir légèrement la carte lorsqu'elle est active */
  }
  
  .protocol-header {
	background: linear-gradient(45deg, #04a0dd, #2575fc);
	color: white;
	padding: 20px;
	border-bottom: none;
	border-radius: 10px 10px 0 0;
  }
  
  .protocol-body {
	padding: 20px;
	display: none;
	background-color: #f9f9f9;
	border-radius: 0 0 10px 10px;
	transition: max-height 0.4s ease-out;
  }
  
  .protocol-body.show {
	display: block;
	animation: fadeIn 0.4s ease;
  }
  
  /* Animation de fondu pour le contenu */
  @keyframes fadeIn {
	from {
	  opacity: 0;
	}
	to {
	  opacity: 1;
	}
  }
  

  /* Animation pour le fondu de la modale */
.fade-in {
  animation: fadeIn 0.5s ease-in-out;
}

@keyframes fadeIn {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}

/* Animation pour le zoom de la modale */
.scale-in {
  animation: scaleIn 0.3s ease-in-out;
}

@keyframes scaleIn {
  from {
    transform: scale(0.7);
  }
  to {
    transform: scale(1);
  }
}

/* Hover effect for calendar events */
.rbc-event {
  transition: background-color 0.3s ease, transform 0.3s ease;
}

.rbc-event:hover {
  background-color: #4a90e2 !important;
  transform: translateY(-6px);
}

/* Animation for menu */
.slide-in-top {
	animation: slide-in-top 0.5s ease-out;
  }
  
  @keyframes slide-in-top {
	0% {
	  transform: translateY(-100%);
	  opacity: 0;
	}
	100% {
	  transform: translateY(0);
	  opacity: 1;
	}
  }
  
  /* Animation for logo */
  .fade-in {
	animation: fade-in 1s ease-in;
  }
  
  @keyframes fade-in {
	0% {
	  opacity: 0;
	}
	100% {
	  opacity: 1;
	}
  }
  
  /* Underline effect on hover */
  .hover-underline:hover {
	text-decoration: underline;
	transition: -webkit-text-decoration 0.3s ease;
	transition: text-decoration 0.3s ease;
	transition: text-decoration 0.3s ease, -webkit-text-decoration 0.3s ease;
  }
  
  /* Custom styling for dropdown */
  .dropdown-menu {
	border-radius: 8px;
	box-shadow: 0 8px 16px rgba(0, 0, 0, 0.1);
  }
  
  .blog-card {
	transition: transform 0.3s ease, box-shadow 0.3s ease;
  }
  
  .blog-card:hover {
	transform: translateY(-10px);
	box-shadow: 0 8px 16px rgba(0, 0, 0, 0.2);
  }
  
  .text-truncate-3 {
	display: -webkit-box;
	-webkit-line-clamp: 3;
	-webkit-box-orient: vertical;
	overflow: hidden;
	text-overflow: ellipsis;
  }
`, "",{"version":3,"sources":["webpack://./src/composant/css/custom.css"],"names":[],"mappings":"AAAA;;;;;yEAKyE;;AAEzE;;;;;;;;;;;;;;;;;;;mCAmBmC;;AAEnC,mBAAmB;AAGnB,2CAA2C;;;;AAI3C;;qCAEqC;AACrC;CACC,yBAAyB;CACzB,WAAW;AACZ;;AAEA;CACC,yBAAyB;CACzB,WAAW;AACZ;;AAEA;CACC,eAAe;AAChB;;AAEA;CACC,eAAe;CACf,qCAAqC;CACrC,cAAc;CACd,qBAAqB;AACtB;;AAEA;CACC,yBAAyB;AAC1B;;AAEA;CACC,iBAAiB;CACjB,eAAe;CACf,cAAc;CACd,qCAAqC;AACtC;;AAEA;;;;;;CAMC,WAAW;CACX,cAAc;CACd,YAAY;CACZ,gBAAgB;CAChB,mBAAmB;CACnB,qCAAqC;AACtC;;AAEA;CACC,eAAe;CACf,gBAAgB;AACjB;;AAEA;CACC,eAAe;CACf,gBAAgB;AACjB;;AAEA;CACC,eAAe;CACf,gBAAgB;AACjB;;AAEA;CACC,eAAe;CACf,gBAAgB;AACjB;;AAEA;CACC,eAAe;CACf,gBAAgB;AACjB;;AAEA;CACC,eAAe;CACf,gBAAgB;AACjB;;AAEA;;;CAGC,WAAW;CACX,YAAY;CACZ,gBAAgB;AACjB;;AAEA;CACC,qBAAqB;CACrB,eAAe;AAChB;;AAEA;CACC,qBAAqB;AACtB;;AAEA,uBAAuB;AACvB;CACC,aAAa;CACb,eAAe;CACf,WAAW;CACX,kBAAkB;CAClB,SAAS;CACT,WAAW;CACX,YAAY;CACZ,iBAAiB;CACjB,eAAe;CACf,WAAW;CACX,yBAAyB;CACzB,qBAAqB;CACrB,mBAAmB;CACnB,aAAa;AACd;;AAEA;CACC,sBAAsB;CACtB,qBAAqB;CACrB,yBAAyB;AAC1B;;AAEA,oBAAoB;AACpB;CACC,yBAAyB;CACzB,WAAW;CACX,SAAS;CACT,kBAAkB;CAClB,kBAAkB;CAClB,eAAe;CACf,yBAAyB;CACzB,gBAAgB;CAChB,iBAAiB;CACjB,qBAAqB;CACrB,qBAAqB;CAIrB,gCAAgC;AACjC;;AAEA;CACC,yBAAyB;CACzB,WAAW;CACX,qBAAqB;AACtB;;AAEA;CACC,WAAW;CACX,yBAAyB;CACzB,kBAAkB;CAClB,kBAAkB;CAClB,eAAe;CACf,gBAAgB;CAChB,yBAAyB;CACzB,iBAAiB;CACjB,qBAAqB;CACrB,qBAAqB;CAIrB,gCAAgC;AACjC;;AAEA;CACC,yBAAyB;CACzB,WAAW;CACX,qBAAqB;AACtB;;AAEA,oBAAoB;AACpB;CACC,eAAe;CACf,OAAO;CACP,MAAM;CACN,cAAc;CACd,WAAW;CACX,kBAAkB;CAClB,YAAY;CACZ,sBAAsB;CACtB,YAAY;CACZ,iBAAiB;CACjB,sBAAsB;AACvB;;AAEA;CACC,QAAQ;CACR,kBAAkB;AACnB;;AAEA,0BAA0B;AAC1B;CACC,gBAAgB;CAChB,eAAe;CACf,yBAAyB;CACzB,kBAAkB;CAClB,WAAW;AACZ;;AAEA;CACC,kBAAkB;CAClB,oBAAoB;CACpB,mBAAmB;CACnB,qBAAqB;AACtB;;AAEA;CACC,kBAAkB;CAClB,WAAW;CACX,WAAW;CACX,WAAW;CACX,SAAS;CACT,UAAU;CACV,YAAY;CACZ,SAAS;CACT,yBAAyB;AAC1B;;AAEA;CACC,kBAAkB;CAClB,WAAW;CACX,WAAW;CACX,WAAW;CACX,SAAS;CACT,UAAU;CACV,YAAY;CACZ,WAAW;CACX,yBAAyB;AAC1B;;;AAGA;;qCAEqC;AACrC;IACI,oBAAoB;IACpB,qBAAqB;IACrB,4BAA4B;IAC5B,gBAAgB;IAChB,uBAAuB;AAC3B;AACA;;qCAEqC;AACrC;IACI,yCAAyC;IACzC,wBAAwB;IACxB,uDAAuD;AAC3D;;AAEA;IACI,wBAAwB;IACxB,uDAAuD;AAC3D;AACA;IACI,wBAAwB;IACxB,uDAAuD;AAC3D;;AAEA;IACI,wBAAwB;IACxB,uDAAuD;AAC3D;;;AAGA;CACC,yBAAyB;CACzB,kBAAkB;CAClB,kBAAkB;CAClB,kBAAkB;CAClB,yBAAyB;CACzB,kBAAkB;CAClB,UAAU;CACV,gBAAgB,EAAE,0CAA0C;CAI5D,gCAAgC;EAC/B;;;;AAIF;CACC,UAAU;CACV,WAAW;CACX,WAAW;CACX,kBAAkB;CAClB,QAAQ;CACR,SAAS;CACT,UAAU;CACV,YAAY;CACZ,yBAAyB;CACzB,2BAA2B;CAC3B,iBAAiB;CACjB,YAAY;CACZ,WAAW;CAIX,gCAAgC;AACjC;;AAEA;CACC,WAAW;CACX,YAAY;AACb;;AAEA;CACC,yBAAyB;AAC1B;;AAEA;CACC,WAAW;CACX,mBAAmB;CACnB,eAAe;CAIf,gCAAgC;AACjC;;AAEA;CACC,cAAc;AACf;;AAEA;CACC,kBAAkB;AACnB;;;;;;AAMA;;qCAEqC;AACrC;CACC,kBAAkB;CAClB,WAAW;CACX,oCAAoC;CACpC,WAAW;CACX,YAAY;CACZ,SAAS;CACT,QAAQ;CACR,UAAU;AACX;;AAEA;CACC,eAAe;CACf,cAAc;CACd,mBAAmB;CACnB,gBAAgB;CAChB,0BAA0B;AAC3B;;AAEA;CACC,QAAQ;CACR,YAAY;CACZ,gBAAgB;CAChB,SAAS;CACT,UAAU;CACV,mBAAmB;CACnB,2BAA2B;CAC3B,UAAU;AACX;;AAEA;CACC,0CAA0C;CAC1C,YAAY;CACZ,WAAW;CACX,kBAAkB;CAClB,kBAAkB;CAClB,kBAAkB;CAClB,yBAAyB;AAC1B;;AAEA;CACC,kBAAkB;CAClB,yBAAyB;CACzB,WAAW;CACX,WAAW;CACX,yBAAyB;CACzB,eAAe;CACf,gBAAgB;CAChB,iBAAiB;AAClB;;AAEA;;qCAEqC;AACrC;CACC,yBAAyB;CACzB,kBAAkB;CAClB,kBAAkB;CAClB,kBAAkB;CAClB,kBAAkB;CAClB,oCAAoC;CACpC,UAAU;CAIV,gCAAgC;AACjC;;AAEA;CACC,UAAU;CACV,WAAW;CACX,WAAW;CACX,kBAAkB;CAClB,QAAQ;CACR,SAAS;CACT,UAAU;CACV,YAAY;CACZ,yBAAyB;CACzB,2BAA2B;CAC3B,iBAAiB;CACjB,YAAY;CACZ,WAAW;CAIX,gCAAgC;AACjC;;AAEA;CACC,WAAW;CACX,YAAY;AACb;;AAEA;CACC,yBAAyB;AAC1B;;AAEA;CACC,WAAW;CACX,mBAAmB;CACnB,eAAe;CAIf,gCAAgC;AACjC;;AAEA;CACC,cAAc;AACf;;AAEA;CACC,kBAAkB;AACnB;;AAEA;;qCAEqC;AACrC;CACC,kBAAkB;CAClB,kBAAkB;AACnB;;AAEA;CACC,WAAW;CACX,YAAY;CACZ,kBAAkB;CAClB,iBAAiB;CACjB,2BAA2B;CAC3B,WAAW;CACX,oCAAoC;CACpC,kBAAkB;CAClB,yBAAyB;CACzB,eAAe;CACf,kBAAkB;CAIlB,gCAAgC;AACjC;;AAEA;CACC,cAAc;CACd,gBAAgB;CAChB,eAAe;CACf,iBAAiB;CACjB,mBAAmB;CACnB,qBAAqB;AACtB;;AAEA;CACC,cAAc;CACd,gBAAgB;CAChB,eAAe;CACf,mBAAmB;AACpB;;AAEA;;qCAEqC;AACrC;CACC,wCAAwC;CACxC,kBAAkB;CAClB,kBAAkB;CAClB,kBAAkB;CAClB,oCAAoC;CACpC,UAAU;CAIV,gCAAgC;AACjC;;AAEA;CACC,cAAc;CACd,mBAAmB;CACnB,iBAAiB;CACjB,eAAe;CAIf,gCAAgC;AACjC;;AAEA;CACC,mBAAmB;CAInB,gCAAgC;AACjC;;AAEA;CAIC,gCAAgC;AACjC;;AAEA;CACC,kBAAkB;CAClB,SAAS;CACT,WAAW;CACX,qBAAqB;CACrB,WAAW;CACX,YAAY;CACZ,eAAe;CACf,kBAAkB;CAClB,iBAAiB;CACjB,yBAAyB;CACzB,cAAc;CACd,kBAAkB;CAClB,4CAA4C;AAC7C;;AAEA;CACC,yBAAyB;CACzB,yBAAyB;AAC1B;;AAEA;;;CAGC,WAAW;AACZ;;AAEA,yBAAyB;AACzB;CACC,yBAAyB;CACzB,kBAAkB;CAClB,aAAa;CACb,kBAAkB;AACnB;;AAEA;CACC,iDAAiD;CACjD,mBAAmB;CACnB,oBAAoB;AACrB;;AAEA;CACC,qBAAqB;CACrB,WAAW;CACX,kBAAkB;CAClB,eAAe;CACf,qBAAqB;CACrB,kBAAkB;CAIlB,gCAAgC;AACjC;;AAEA;CACC,kBAAkB;CAClB,kBAAkB;AACnB;;AAEA;CACC,mBAAmB;AACpB;;AAEA;CACC,WAAW;AACZ;;AAEA;CACC,qBAAqB;CACrB,QAAQ;CACR,SAAS;CACT,SAAS;CACT,QAAQ;CACR,kBAAkB;CAClB,cAAc;CACd,WAAW;CACX,kCAAkC;CAClC,qCAAqC;CACrC,eAAe;CACf,uBAAuB;CACvB,2BAA2B;AAC5B;;AAEA,sBAAsB;AACtB;CACC,yBAAyB;CACzB,qBAAqB;CACrB,kBAAkB;CAClB,qBAAqB;CACrB,gBAAgB;CAChB,WAAW;CACX,WAAW;CACX,eAAe;AAChB;;AAEA;CACC,yBAAyB;CACzB,kBAAkB;CAClB,kBAAkB;AACnB;;AAEA,wBAAwB;AACxB;CACC,oCAAoC;CACpC,kBAAkB;CAClB,YAAY;AACb;;AAEA,eAAe;AACf;CACC,WAAW;CACX,yBAAyB;CACzB,aAAa;CACb,kBAAkB;CAClB,kBAAkB;AACnB;;AAEA;CACC,WAAW;CACX,kBAAkB;CAClB,eAAe;CACf,iBAAiB;AAClB;;AAEA;CACC,gBAAgB;CAChB,cAAc;CACd,eAAe;AAChB;;AAEA;;qCAEqC;AACrC;CACC,yDAAmD;CACnD,sBAAsB;CACtB,+BAA+B;CAC/B,kBAAkB;AACnB;;AAEA;CACC,kBAAkB;CAClB,WAAW;CACX,oCAAoC;CACpC,WAAW;CACX,YAAY;CACZ,SAAS;CACT,QAAQ;AACT;;AAEA;CACC,kBAAkB;CAClB,WAAW;CACX,kBAAkB;CAClB,iBAAiB;CACjB,kBAAkB;CAClB,8CAA8C;AAC/C;;AAEA;CACC,cAAc;CACd,yBAAyB;CACzB,eAAe;CACf,gBAAgB;CAChB,mBAAmB;AACpB;;AAEA;CACC,WAAW;CACX,mBAAmB;CACnB,YAAY;CACZ,aAAa;CACb,YAAY;CACZ,2BAA2B;CAC3B,qBAAqB;AACtB;;AAEA;CACC,oCAAoC;CACpC,kBAAkB;AACnB;;AAEA;CACC,WAAW;CACX,kBAAkB;CAClB,kBAAkB;AACnB;;AAEA;CACC,0CAA0C;CAC1C,WAAW;CACX,cAAc;CACd,WAAW;CACX,OAAO;CACP,gBAAgB;CAChB,kBAAkB;CAClB,QAAQ;CACR,QAAQ;CACR,2BAA2B;CAC3B,WAAW;CACX,WAAW;AACZ;;AAEA;CACC,WAAW;CACX,oBAAoB;AACrB;;AAEA;CACC,kBAAkB;CAClB,WAAW;CACX,yBAAyB;AAC1B;;AAEA;CACC,eAAe;CACf,gBAAgB;CAChB,WAAW;CACX,kBAAkB;AACnB;;AAEA;CACC,cAAc;CACd,gBAAgB;CAChB,kBAAkB;AACnB;;AAEA;CACC,WAAW;CACX,YAAY;CACZ,eAAe;CACf,kBAAkB;CAClB,yBAAyB;CACzB,kBAAkB;CAClB,iCAAiC;CACjC,oCAAoC;CAIpC,gCAAgC;AACjC;;AAEA;CACC,oCAAoC;CACpC,sBAAsB;AACvB;;AAEA;;qCAEqC;AACrC;CACC,kBAAkB;CAClB,mBAAmB;CACnB,oCAAoC;CACpC,gBAAgB;CAIhB,gCAAgC;AACjC;;AAEA;CACC,yBAAyB;AAC1B;;AAEA;CACC,4BAA4B;CAC5B,kBAAkB;CAClB,SAAS;CACT,WAAW;CACX,8BAA8B;CAC9B,qBAAqB;CACrB,yBAAyB;CACzB,qDAAqD;CAIrD,gCAAgC;AACjC;;AAEA;CACC,yBAAyB;AAC1B;;AAEA;CACC,WAAW;CACX,eAAe;CACf,qBAAqB;CACrB,kBAAkB;CAClB,yBAAyB;AAC1B;;AAEA;CACC,WAAW;CACX,eAAe;CACf,yBAAyB;CACzB,gBAAgB;AACjB;;AAEA,kDAAkD;;AAElD;CACC;;EAEC,eAAe;EACf,+DAA+D;CAChE;;CAEA;;EAEC,cAAc;EACd,+DAA+D;CAChE;AACD;;AAEA,kDAAkD;AAClD;CACC;;EAEC,eAAe;EACf,2EAA2E;CAC5E;;CAEA;;EAEC,cAAc;EACd,+DAA+D;CAChE;AACD;;AAEA;CACC,kBAAkB;CAClB,QAAQ;CACR,UAAU;CACV,yBAAyB;AAC1B;;AAEA;CACC,WAAW;CACX,YAAY;CACZ,kBAAkB;CAClB,iBAAiB;CACjB,WAAW;CACX,iDAAiD;CACjD,yBAAyB;CACzB,qBAAqB;CACrB,eAAe;CAIf,gCAAgC;AACjC;;AAEA;CACC,kBAAkB;AACnB;;AAEA;CACC,yBAAyB;AAC1B;;AAEA;;qCAEqC;AACrC;CACC,sDAAsD;CACtD,yBAAyB;CACzB,eAAe,EAAE,sCAAsC;AACxD;;AAEA;CACC,sDAAsD;CACtD,yBAAyB;CACzB,eAAe,EAAE,sCAAsC;AACxD;;;AAGA;;qCAEqC;AACrC;CACC,yDAAsD;CACtD,sBAAsB;CACtB,+BAA+B;CAC/B,kBAAkB;CAClB,kBAAkB;CAClB,UAAU;AACX;;AAEA;CACC,kBAAkB;CAClB,WAAW;CACX,oCAAoC;CACpC,WAAW;CACX,YAAY;CACZ,SAAS;CACT,QAAQ;CACR,WAAW;AACZ;;AAEA;CACC,eAAe;CACf,cAAc;CACd,gBAAgB;CAChB,mBAAmB;AACpB;;AAEA;CACC,WAAW;CACX,gBAAgB;CAChB,eAAe;CACf,iBAAiB;CACjB,mBAAmB;AACpB;;AAEA;CACC,WAAW;CACX,0BAA0B;AAC3B;;AAEA;CACC,WAAW;CACX,iBAAiB;AAClB;;AAEA;CACC,kBAAkB;CAClB,qBAAqB;CACrB,WAAW;CACX,YAAY;CACZ,iBAAiB;CACjB,WAAW;CACX,eAAe;CACf,mBAAmB;CACnB,mBAAmB;CACnB,yBAAyB;AAC1B;;AAEA;CACC,kBAAkB;CAClB,WAAW;CACX,WAAW;CACX,YAAY;CACZ,mBAAmB;CACnB,mBAAmB;CACnB,MAAM;CACN,yBAAyB;CACzB,iDAAiD;CACjD,OAAO;CACP,QAAQ;CACR,SAAS;CACT,UAAU;AACX;;AAEA;CACC,kBAAkB;CAClB,WAAW;CACX,WAAW;CACX,YAAY;CACZ,yBAAyB;CACzB,mBAAmB;CACnB,SAAS;CACT,UAAU;CACV,QAAQ;CACR,SAAS;CACT,UAAU;AACX;;AAEA;CACC,UAAU;CACV,kBAAkB;AACnB;;AAEA;CACC,WAAW;AACZ;;AAEA,kBAAkB;AAClB;CACC;EACC,mBAAmB;EACnB;CACD;;CAEA;EACC,sBAAsB;EACtB;CACD;;CAEA;EACC,qBAAqB;EACrB;CACD;AACD;;AAEA;;qCAEqC;AACrC;CACC,kBAAkB;CAClB,kBAAkB;CAClB,oCAAoC;CACpC,gBAAgB;CAIhB,gCAAgC;AACjC;;AAEA;CACC,yBAAyB;AAC1B;;AAEA;CACC,aAAa;AACd;;AAEA;CACC,mBAAmB;AACpB;;AAEA;CACC,kBAAkB;CAClB,eAAe;CACf,cAAc;CACd,6BAA6B;AAC9B;;AAEA;CACC,cAAc;CAId,gCAAgC;AACjC;;AAEA;CACC,cAAc;AACf;;AAEA;CACC,kBAAkB;CAClB,YAAY;CACZ,QAAQ;CACR,eAAe;CACf,YAAY;CACZ,2BAA2B;AAC5B;;AAEA;CACC,4BAA4B;AAC7B;;AAEA;CACC,aAAa;AACd;;AAEA;CACC,iBAAiB;CACjB,mBAAmB;AACpB;;AAEA;CACC,cAAc;CACd,eAAe;CAIf,gCAAgC;AACjC;;AAEA;CACC,cAAc;AACf;;AAEA;CACC,kBAAkB;AACnB;;AAEA;CACC,kBAAkB;CAClB,WAAW;CACX,QAAQ;CACR,SAAS;CACT,oCAAoC;CACpC,QAAQ;CACR,UAAU;CACV,SAAS;CACT,UAAU;CACV,YAAY;CACZ,UAAU;CAIV,gCAAgC;AACjC;;AAEA;CACC,WAAW;CACX,YAAY;CACZ,UAAU;AACX;;AAEA;CACC,kBAAkB;CAClB,SAAS;CACT,WAAW;CACX,qBAAqB;CACrB,WAAW;CACX,YAAY;CACZ,eAAe;CACf,kBAAkB;CAClB,iBAAiB;CACjB,yBAAyB;CACzB,cAAc;CACd,kBAAkB;CAClB,4CAA4C;CAC5C,UAAU;AACX;;AAEA,oBAAoB;AACpB;CACC,oCAAoC;CACpC,kBAAkB;CAClB,gBAAgB;AACjB;;AAEA,cAAc;AACd;CACC,mBAAmB;AACpB;;AAEA;CACC,kBAAkB;CAClB,eAAe;CACf,cAAc;CACd,mBAAmB;CACnB,6BAA6B;AAC9B;;AAEA;CACC,cAAc;CAId,gCAAgC;AACjC;;AAEA;CACC,cAAc;AACf;;AAEA;CACC,kBAAkB;CAClB,YAAY;CACZ,QAAQ;CACR,eAAe;CACf,YAAY;CACZ,2BAA2B;AAC5B;;AAEA;CACC,4BAA4B;AAC7B;;AAEA;CACC,aAAa;AACd;;AAEA,eAAe;AACf;CACC,WAAW;CACX,kBAAkB;CAClB,8BAA8B;CAC9B,mBAAmB;AACpB;;AAEA;CACC,WAAW;CACX,kBAAkB;CAClB,eAAe;CACf,iBAAiB;AAClB;;AAEA;CACC,gBAAgB;CAChB,cAAc;CACd,eAAe;AAChB;;AAEA;CACC,cAAc;CACd,kBAAkB;AACnB;;AAEA;CACC,cAAc;CACd,eAAe;CACf,oBAAoB;AACrB;;AAEA;CACC,mBAAmB;AACpB;;AAEA,iBAAiB;AACjB;CACC,wCAAwC;CACxC,qBAAqB;AACtB;;AAEA;CACC,eAAe;CACf,cAAc;CACd,qBAAqB;CACrB,iBAAiB;CACjB,kBAAkB;CAIlB,gCAAgC;AACjC;;AAEA;CACC,kBAAkB;CAClB,YAAY;CACZ,QAAQ;CACR,eAAe;CACf,2BAA2B;CAC3B,WAAW;AACZ;;AAEA;CACC,iBAAiB;AAClB;;AAEA;CACC,kBAAkB;AACnB;;AAEA;CACC,aAAa;AACd;;AAEA;CACC,cAAc;AACf;;AAEA;CACC,eAAe;CACf,yBAAyB;CACzB,WAAW;CACX,qBAAqB;CACrB,WAAW;CACX,YAAY;CACZ,iBAAiB;CACjB,kBAAkB;CAClB,qBAAqB;CACrB,mBAAmB;CAInB,gCAAgC;AACjC;;AAEA;CACC,yBAAyB;AAC1B;;AAEA,iBAAiB;AACjB;CACC,WAAW;CACX,oBAAoB;CACpB,qBAAqB;CACrB,mBAAmB;CACnB,2CAA2C;AAC5C;;AAEA;CACC,mBAAmB;CACnB,kBAAkB;CAClB,kBAAkB;AACnB;;AAEA;CACC,WAAW;CACX,YAAY;AACb;;AAEA;CACC,sBAAsB;CAGtB,mBAAmB;CAInB,gCAAgC;AACjC;;AAEA;CACC,WAAW;CACX,yBAAyB;CACzB,kBAAkB;AACnB;;AAEA;CACC,mBAAmB;AACpB;;AAEA;CACC,eAAe;CACf,cAAc;AACf;;AAEA;CACC,eAAe;CACf,gBAAgB;CAChB,WAAW;AACZ;;AAEA;CACC,cAAc;CACd,eAAe;CACf,yBAAyB;AAC1B;;AAEA;CACC,cAAc;CACd,eAAe;CACf,gBAAgB;AACjB;;AAEA;CACC,yBAAyB;AAC1B;;AAEA,kBAAkB;AAClB;CACC,sBAAsB;CACtB,oCAAoC;CACpC,kBAAkB;CAClB,eAAe;CACf,YAAY;AACb;;AAEA;CACC,sBAAsB;CACtB,oCAAoC;CACpC,kBAAkB;CAClB,eAAe;AAChB;;AAEA;CACC,gBAAgB;CAChB,yBAAyB;AAC1B;;AAEA;;qCAEqC;AACrC;CACC,yBAAyB;AAC1B;;AAEA;CACC,kBAAkB;AACnB;;AAEA,kBAAkB;AAClB;CACC,WAAW;CACX,YAAY;CACZ,iBAAiB;CACjB,kBAAkB;CAClB,mBAAmB;CACnB,WAAW;CACX,yBAAyB;CACzB,qBAAqB;CAIrB,gCAAgC;AACjC;;AAEA;CACC,yBAAyB;AAC1B;;AAEA,mBAAmB;AACnB;CACC,8CAA8C;CAC9C,iBAAiB;CACjB,gBAAgB;CAChB,mBAAmB;AACpB;;AAEA;CACC,mCAAmC;AACpC;;AAEA;CACC,kCAAkC;AACnC;;AAEA;;CAEC,cAAc;CACd,eAAe;CAIf,gCAAgC;AACjC;;AAEA;CACC,oBAAoB;AACrB;;AAEA;CACC,kBAAkB;AACnB;;AAEA;CACC,cAAc;AACf;;AAEA,kBAAkB;AAClB;CACC,8CAA8C;CAC9C,iBAAiB;CACjB,oBAAoB;CACpB,yBAAyB;AAC1B;;AAEA,gBAAgB;AAChB;CACC,mCAAmC;AACpC;;AAEA;CACC,kCAAkC;AACnC;;AAEA;CACC,cAAc;CACd,eAAe;CACf,qBAAqB;CACrB,oBAAoB;CAIpB,gCAAgC;AACjC;;AAEA;CACC,cAAc;AACf;;AAEA,qBAAqB;AACrB;CACC,cAAc;CACd,eAAe;CACf,mBAAmB;AACpB;;AAEA;;qCAEqC;AACrC;CACC,yDAAwD;CACxD,4BAA4B;CAC5B,+BAA+B;CAC/B,kBAAkB;CAClB,sBAAsB;CACtB,kBAAkB;CAClB,kBAAkB;CAClB,UAAU;AACX;;AAEA;CACC,oCAAoC;CACpC,kBAAkB;CAClB,WAAW;CACX,YAAY;CACZ,WAAW;CACX,QAAQ;CACR,SAAS;CACT,WAAW;AACZ;;AAEA;CACC,gBAAgB;CAChB,eAAe;CACf,WAAW;CACX,gBAAgB;CAChB,iBAAiB;AAClB;;AAEA;CACC,kBAAkB;AACnB;;AAEA;CACC,kBAAkB;CAClB,WAAW;CACX,UAAU;CACV,WAAW;CACX,yBAAyB;CACzB,QAAQ;CACR,WAAW;CACX,2BAA2B;AAC5B;;AAEA;CACC,kBAAkB;CAClB,WAAW;CACX,UAAU;CACV,WAAW;CACX,yBAAyB;CACzB,QAAQ;CACR,YAAY;CACZ,2BAA2B;AAC5B;;AAEA;CACC,YAAY;CACZ,kBAAkB;CAClB,YAAY;CACZ,qBAAqB;CACrB,6BAA6B;AAC9B;;AAEA;CACC,WAAW;CACX,WAAW;CACX,qBAAqB;AACtB;;AAEA;CACC,cAAc;AACf;;AAEA;CACC,WAAW;AACZ;;AAEA;;qCAEqC;AACrC;CACC,8BAA8B;CAC9B,2BAA2B;CAC3B,yBAAyB;CACzB,aAAa;AACd;;AAEA;CACC,sBAAsB;CACtB,mBAAmB;CACnB,aAAa;AACd;;AAEA;CACC,4BAA4B;AAC7B;;AAEA;CACC,eAAe;CACf,0BAA0B;CAC1B,qBAAqB;CACrB,kBAAkB;CAClB,eAAe;CACf,gBAAgB;CAChB,WAAW;CACX,yBAAyB;CACzB,mBAAmB;CACnB,yBAAyB;CAIzB,gCAAgC;AACjC;;AAEA;;CAEC,WAAW;CACX,yBAAyB;AAC1B;;AAEA;CACC,mBAAmB;CACnB,kBAAkB;CAClB,kBAAkB;CAClB,2CAA2C;CAC3C,kBAAkB;CAClB,gBAAgB;AACjB;;AAEA;CACC,kBAAkB;CAClB,gBAAgB;AACjB;;AAEA;CACC,YAAY;CACZ,OAAO;CACP,kBAAkB;CAClB,MAAM;CACN,WAAW;CACX,kCAAkC;CAIlC,gCAAgC;AACjC;;AAEA;CACC,oCAAoC;AACrC;;AAEA;CACC,WAAW;CACX,eAAe;CACf,kBAAkB;CAClB,UAAU;CACV,SAAS;CACT,yBAAyB;CACzB,UAAU;CACV,YAAY;CACZ,QAAQ;CACR,WAAW;CACX,YAAY;CACZ,kBAAkB;CAClB,mBAAmB;CACnB,2BAA2B;CAC3B,iBAAiB;CAIjB,gCAAgC;AACjC;;AAEA;CACC,UAAU;AACX;;AAEA;CACC,WAAW;AACZ;;AAEA;CACC,cAAc;CACd,eAAe;CACf,gBAAgB;CAChB,iBAAiB;CAIjB,gCAAgC;AACjC;;AAEA;CACC,yBAAyB;CACzB,WAAW;AACZ;;AAEA;;qCAEqC;AACrC,iBAAiB;AACjB;CACC,sBAAsB;CACtB,oCAAoC;CACpC,kBAAkB;CAClB,eAAe;CACf,YAAY;AACb;;AAEA;CACC,sBAAsB;CACtB,oCAAoC;CACpC,kBAAkB;CAClB,eAAe;AAChB;;AAEA;CACC,gBAAgB;CAChB,yBAAyB;AAC1B;;AAEA;CACC,cAAc;CACd,yBAAyB;CACzB,qBAAqB;CACrB,aAAa;AACd;;AAEA,iBAAiB;AACjB;CACC,mBAAmB;CACnB,WAAW;CACX,qBAAqB;AACtB;;AAEA;CACC,kBAAkB;AACnB;;AAEA;CACC,WAAW;CACX,WAAW;CACX,iBAAiB;AAClB;;AAEA;CACC,cAAc;CACd,eAAe;AAChB;;AAEA;CACC,UAAU;CACV,WAAW;CACX,gBAAgB;AACjB;;AAEA;CACC,kBAAkB;AACnB;;AAEA;CACC,kBAAkB;AACnB;;AAEA;CACC,cAAc;CACd,qBAAqB;AACtB;;AAEA;CACC,cAAc;AACf;;AAEA,QAAQ;AACR;CACC,WAAW;CACX,WAAW;CACX,aAAa;AACd;;;;AAIA,eAAe;AACf;CACC,yBAAyB;CACzB,kBAAkB;CAClB,2CAA2C;EAC1C;;EAEA;CACD,yBAAyB;CACzB,YAAY;CACZ,kBAAkB;CAClB,YAAY;EACX;;EAEA;CACD,yBAAyB;CACzB,YAAY;CACZ,kBAAkB;EACjB;;EAEA;CACD,yBAAyB;EACxB;;EAEA;CACD,YAAY;EACX;;EAEA;CACD,eAAe,EAAE,wCAAwC;CACzD,mBAAmB,EAAE,0CAA0C;CAC/D,gBAAgB,EAAE,0BAA0B;CAC5C,uBAAuB,EAAE,2DAA2D;EACnF;;;EAGA;CACD,gBAAgB;CAChB,cAAc;CACd,aAAa;CACb,yBAAyB,EAAE,sDAAsD;CACjF,mBAAmB;EAClB;;GAEC,QAAQ;EACT;CACD,mBAAmB;CACnB,kBAAkB;CAClB,wCAAwC;CACxC,gCAAgC;EAC/B;;EAEA;CACD,yBAAyB;CACzB,WAAW;CACX,aAAa;CACb,iBAAiB;CACjB,gBAAgB;CAChB,eAAe;CACf,aAAa;CACb,8BAA8B;CAC9B,mBAAmB;CACnB,kBAAkB;CAClB,sCAAsC;EACrC;;EAEA;CACD,yBAAyB;EACxB;;EAEA;CACD,iBAAiB;EAChB;;EAEA;CACD,yBAAyB;CACzB,WAAW;CACX,aAAa;CACb,eAAe;CACf,gBAAgB;CAChB,6BAA6B;CAC7B,0BAA0B;EACzB;;EAEA;CACD,yBAAyB;EACxB;;;;;CAKD,0DAA0D;;AAE3D,qBAAqB;AACrB;CACC,eAAe;CACf,QAAQ,EAAE,qBAAqB;CAC/B,UAAU,EAAE,2BAA2B;CACvC,aAAa,EAAE,2DAA2D;CAC1E,YAAY;CACZ,kBAAkB;EACjB;;EAEA;CACD,gBAAgB;EACf;;EAEA;CACD;GACE,QAAQ;GACR,UAAU;CACZ;EACC;;EAEA;CACD;GACE,SAAS;GACT,WAAW;CACb;EACC;;;;AAIF,eAAe;AACf;CACC,2BAA2B;CAC3B,qBAAqB;CACrB,4BAA4B;EAC3B;;EAEA,gBAAgB;EAChB;CACD,2BAA2B;CAC3B,qBAAqB;CACrB,0BAA0B;CAC1B,4BAA4B;;EAE3B;;EAEA,sCAAsC;;AAExC;IACI,yBAAyB,EAAE,8BAA8B;AAC7D;;AAEA;IACI,yBAAyB,EAAE,8BAA8B;AAC7D;;AAEA,yDAAyD;AACzD;CACC,mBAAmB;CACnB,eAAe;CACf,+BAA+B;CAC/B,yBAAyB;CACzB,wCAAwC;EACvC;;EAEA;CACD,sBAAsB,EAAE,wDAAwD;EAC/E;;EAEA;CACD,oDAAoD;CACpD,YAAY;CACZ,aAAa;CACb,mBAAmB;CACnB,4BAA4B;EAC3B;;EAEA;CACD,aAAa;CACb,aAAa;CACb,yBAAyB;CACzB,4BAA4B;CAC5B,oCAAoC;EACnC;;EAEA;CACD,cAAc;CACd,2BAA2B;EAC1B;;EAEA,uCAAuC;EACvC;CACD;GACE,UAAU;CACZ;CACA;GACE,UAAU;CACZ;EACC;;;EAGA,yCAAyC;AAC3C;EACE,kCAAkC;AACpC;;AAEA;EACE;IACE,UAAU;EACZ;EACA;IACE,UAAU;EACZ;AACF;;AAEA,wCAAwC;AACxC;EACE,mCAAmC;AACrC;;AAEA;EACE;IACE,qBAAqB;EACvB;EACA;IACE,mBAAmB;EACrB;AACF;;AAEA,qCAAqC;AACrC;EACE,2DAA2D;AAC7D;;AAEA;EACE,oCAAoC;EACpC,2BAA2B;AAC7B;;AAEA,uBAAuB;AACvB;CACC,qCAAqC;EACpC;;EAEA;CACD;GACE,4BAA4B;GAC5B,UAAU;CACZ;CACA;GACE,wBAAwB;GACxB,UAAU;CACZ;EACC;;EAEA,uBAAuB;EACvB;CACD,6BAA6B;EAC5B;;EAEA;CACD;GACE,UAAU;CACZ;CACA;GACE,UAAU;CACZ;EACC;;EAEA,8BAA8B;EAC9B;CACD,0BAA0B;CAC1B,6CAAqC;CAArC,qCAAqC;CAArC,wEAAqC;EACpC;;EAEA,gCAAgC;EAChC;CACD,kBAAkB;CAClB,yCAAyC;EACxC;;EAEA;CACD,qDAAqD;EACpD;;EAEA;CACD,4BAA4B;CAC5B,yCAAyC;EACxC;;EAEA;CACD,oBAAoB;CACpB,qBAAqB;CACrB,4BAA4B;CAC5B,gBAAgB;CAChB,uBAAuB;EACtB","sourcesContent":["/*========================================================================\r\n\r\n\tTemplate Name: Bootstrap 5 Multipurpose Business Website Template\r\n\tAuthor: Rainbow Design\r\n\r\n========================================================================*/\r\n\r\n/*----------------------------------\r\n\r\n\tTable of contents\r\n\t\r\n\t01. Common\r\n\t02. Header\r\n\t03. Slider\r\n\t04. Feature area\r\n\t05. Counter area\r\n\t06. Services\r\n\t07. Testimonials\r\n\t08. Team\r\n\t09. Call to action\r\n\t10. Blog\r\n\t11. Footer\r\n\t12. Inner page title\r\n\t13. Portfolio\r\n\t14. Contact form\r\n\t\t\r\n----------------------------------*/\r\n\r\n/* Theme Font Use */\r\n\r\n@import url('https://fonts.googleapis.com/css2?family=Montserrat:ital,wght@0,100;0,200;0,300;0,400;0,500;0,600;0,700;0,800;0,900;1,100;1,200;1,300;1,400;1,500;1,600;1,700;1,800;1,900&display=swap');\r\n/* font-family: 'Montserrat', sans-serif; */\r\n\r\n\r\n\r\n/* ===================================\r\n\t01. Common\r\n=================================== */\r\n::selection {\r\n\tbackground-color: #00bcd4;\r\n\tcolor: #fff;\r\n}\r\n\r\n::-moz-selection {\r\n\tbackground-color: #00bcd4;\r\n\tcolor: #fff;\r\n}\r\n\r\nimg {\r\n\tmax-width: 100%;\r\n}\r\n\r\nbody {\r\n\tfont-size: 16px;\r\n\tfont-family: 'Montserrat', sans-serif;\r\n\tcolor: #252525;\r\n\tletter-spacing: 0.5px;\r\n}\r\n\r\n.theme-bg-light {\r\n\tbackground-color: #1D4DDC;\r\n}\r\n\r\np {\r\n\tline-height: 24px;\r\n\tfont-size: 14px;\r\n\tcolor: #6c757d;\r\n\tfont-family: 'Montserrat', sans-serif;\r\n}\r\n\r\nh1,\r\nh2,\r\nh3,\r\nh4,\r\nh5,\r\nh6 {\r\n\tmargin: 0px;\r\n\tcolor: #202020;\r\n\tpadding: 0px;\r\n\tline-height: 1.4;\r\n\tletter-spacing: 1px;\r\n\tfont-family: 'Montserrat', sans-serif;\r\n}\r\n\r\nh1 {\r\n\tfont-size: 60px;\r\n\tfont-weight: 700;\r\n}\r\n\r\nh2 {\r\n\tfont-size: 36px;\r\n\tfont-weight: 700;\r\n}\r\n\r\nh3 {\r\n\tfont-size: 26px;\r\n\tfont-weight: 700;\r\n}\r\n\r\nh4 {\r\n\tfont-size: 24px;\r\n\tfont-weight: 700;\r\n}\r\n\r\nh5 {\r\n\tfont-size: 18px;\r\n\tfont-weight: 700;\r\n}\r\n\r\nh6 {\r\n\tfont-size: 16px;\r\n\tfont-weight: 700;\r\n}\r\n\r\nul,\r\nol,\r\nli {\r\n\tmargin: 0px;\r\n\tpadding: 0px;\r\n\tlist-style: none;\r\n}\r\n\r\na {\r\n\ttext-decoration: none;\r\n\tcursor: pointer;\r\n}\r\n\r\na:hover {\r\n\ttext-decoration: none;\r\n}\r\n\r\n/* --- Top Scroll --- */\r\n.scroll-top {\r\n\tdisplay: none;\r\n\tposition: fixed;\r\n\tbottom: 2px;\r\n\ttext-align: center;\r\n\tright: 2%;\r\n\twidth: 40px;\r\n\theight: 40px;\r\n\tline-height: 40px;\r\n\tfont-size: 12px;\r\n\tcolor: #fff;\r\n\tbackground-color: #00bcd4;\r\n\ttext-decoration: none;\r\n\tborder-radius: 100%;\r\n\tz-index: 9999;\r\n}\r\n\r\n.scroll-top:hover {\r\n\tcolor: #fff !important;\r\n\ttext-decoration: none;\r\n\tbackground-color: #018fa2;\r\n}\r\n\r\n/* --- Buttons --- */\r\n.btn-style-1 {\r\n\tbackground-color: #00bcd4;\r\n\tcolor: #fff;\r\n\tborder: 0;\r\n\tborder-radius: 4px;\r\n\tpadding: 12px 20px;\r\n\tfont-size: 14px;\r\n\ttext-transform: uppercase;\r\n\tfont-weight: 600;\r\n\tline-height: 22px;\r\n\ttext-decoration: none;\r\n\tdisplay: inline-block;\r\n\t-webkit-transition: all 0.3s ease-in-out;\r\n\t-moz-transition: all 0.3s ease-in-out;\r\n\t-o-transition: all 0.3s ease-in-out;\r\n\ttransition: all 0.3s ease-in-out;\r\n}\r\n\r\n.btn-style-1:hover {\r\n\tbackground-color: #018fa2;\r\n\tcolor: #fff;\r\n\ttext-decoration: none;\r\n}\r\n\r\n.btn-style-2 {\r\n\tcolor: #fff;\r\n\tbackground-color: #202020;\r\n\tborder-radius: 4px;\r\n\tpadding: 12px 20px;\r\n\tfont-size: 14px;\r\n\tfont-weight: 600;\r\n\ttext-transform: uppercase;\r\n\tline-height: 22px;\r\n\ttext-decoration: none;\r\n\tdisplay: inline-block;\r\n\t-webkit-transition: all 0.3s ease-in-out;\r\n\t-moz-transition: all 0.3s ease-in-out;\r\n\t-o-transition: all 0.3s ease-in-out;\r\n\ttransition: all 0.3s ease-in-out;\r\n}\r\n\r\n.btn-style-2:hover {\r\n\tbackground-color: #00bcd4;\r\n\tcolor: #fff;\r\n\ttext-decoration: none;\r\n}\r\n\r\n/* --- Loading --- */\r\n#preloader {\r\n\tposition: fixed;\r\n\tleft: 0;\r\n\ttop: 0;\r\n\tz-index: 99999;\r\n\twidth: 100%;\r\n\ttext-align: center;\r\n\theight: 100%;\r\n\tvertical-align: middle;\r\n\theight: 100%;\r\n\toverflow: visible;\r\n\tbackground-color: #fff;\r\n}\r\n\r\n#preloader .spinner-grow {\r\n\ttop: 50%;\r\n\tposition: relative;\r\n}\r\n\r\n/* --- section title --- */\r\n.section-title h2 {\r\n\tfont-weight: 600;\r\n\tfont-size: 34px;\r\n\ttext-transform: uppercase;\r\n\tposition: relative;\r\n\tcolor: #333;\r\n}\r\n\r\n.section-title h2 span {\r\n\tposition: relative;\r\n\tpadding-bottom: 16px;\r\n\tmargin-bottom: 45px;\r\n\tdisplay: inline-block;\r\n}\r\n\r\n.section-title h2 span:after {\r\n\tposition: absolute;\r\n\tcontent: \"\";\r\n\twidth: 30px;\r\n\theight: 1px;\r\n\tleft: 0px;\r\n\tright: 0px;\r\n\tmargin: auto;\r\n\tbottom: 0;\r\n\tbackground-color: #00bcd4;\r\n}\r\n\r\n.section-title h2 span:before {\r\n\tposition: absolute;\r\n\tcontent: \"\";\r\n\twidth: 50px;\r\n\theight: 1px;\r\n\tleft: 0px;\r\n\tright: 0px;\r\n\tmargin: auto;\r\n\tbottom: 3px;\r\n\tbackground-color: #00bcd4;\r\n}\r\n\r\n\r\n/* ===================================\r\n\tNEW CARD CLUB \r\n=================================== */\r\n.text-truncate-3 {\r\n    display: -webkit-box;\r\n    -webkit-line-clamp: 3;\r\n    -webkit-box-orient: vertical;\r\n    overflow: hidden;\r\n    text-overflow: ellipsis;\r\n}\r\n/* ===================================\r\n\t04. Feature area\r\n=================================== */\r\n.feature-area {\r\n    background-color: var(--background-color);\r\n    color: var(--text-color);\r\n    transition: background-color 0.3s ease, color 0.3s ease;\r\n}\r\n\r\n.feature-area h1{\r\n    color: var(--text-color);\r\n    transition: background-color 0.3s ease, color 0.3s ease;\r\n}\r\n.feature-area h2{\r\n    color: var(--text-color);\r\n    transition: background-color 0.3s ease, color 0.3s ease;\r\n}\r\n\r\n.feature-area p{\r\n    color: var(--text-color);\r\n    transition: background-color 0.3s ease, color 0.3s ease;\r\n}\r\n\r\n\r\n.card {\r\n\tbackground-color: #cbd9ff;\r\n\tposition: relative;\r\n\tborder-radius: 6px;\r\n\tpadding: 20px 20px;\r\n\tborder: 2px solid #000000;\r\n\ttext-align: center;\r\n\tz-index: 0;\r\n\tfont-weight: 500; /* Épaissir le texte sans le rendre gras */\r\n\t-webkit-transition: all 0.3s ease-in-out;\r\n\t-moz-transition: all 0.3s ease-in-out;\r\n\t-o-transition: all 0.3s ease-in-out;\r\n\ttransition: all 0.3s ease-in-out;\r\n  }\r\n  \r\n  \r\n\r\n.card:after {\r\n\twidth: 0px;\r\n\theight: 0px;\r\n\tcontent: \"\";\r\n\tposition: absolute;\r\n\ttop: 50%;\r\n\tleft: 0px;\r\n\tright: 0px;\r\n\tmargin: auto;\r\n\tbackground-color: #00e1ff;\r\n\ttransform: translateY(-50%);\r\n\tborder-radius: 0%;\r\n\topacity: 0.2;\r\n\tz-index: -1;\r\n\t-webkit-transition: all 0.5s ease-in-out;\r\n\t-moz-transition: all 0.5s ease-in-out;\r\n\t-o-transition: all 0.5s ease-in-out;\r\n\ttransition: all 0.5s ease-in-out;\r\n}\r\n\r\n.card:hover:after {\r\n\twidth: 100%;\r\n\theight: 100%;\r\n}\r\n\r\n.card:hover {\r\n\tborder: 2px solid #00cee9;\r\n}\r\n\r\n.card .icon {\r\n\tcolor: #333;\r\n\tmargin-bottom: 10px;\r\n\tfont-size: 35px;\r\n\t-webkit-transition: all 0.3s ease-in-out;\r\n\t-moz-transition: all 0.3s ease-in-out;\r\n\t-o-transition: all 0.3s ease-in-out;\r\n\ttransition: all 0.3s ease-in-out;\r\n}\r\n\r\n.card:hover .icon {\r\n\tcolor: #00bcd4;\r\n}\r\n\r\n.card h4 {\r\n\tmargin-bottom: 2px;\r\n}\r\n\r\n\r\n\r\n\r\n\r\n/* ===================================\r\n\t03. Slider\r\n=================================== */\r\n.slider .carousel-item:after {\r\n\tposition: absolute;\r\n\tcontent: \"\";\r\n\tbackground-color: rgba(0, 0, 0, 0.5);\r\n\twidth: 100%;\r\n\theight: 100%;\r\n\tleft: 0px;\r\n\ttop: 0px;\r\n\tz-index: 1;\r\n}\r\n\r\n.slider h2 {\r\n\tfont-size: 40px;\r\n\tcolor: #202020;\r\n\tmargin-bottom: 10px;\r\n\tfont-weight: 600;\r\n\ttext-decoration: underline;\r\n}\r\n\r\n.slider .carousel-caption {\r\n\ttop: 50%;\r\n\tbottom: auto;\r\n\tpadding-top: 0px;\r\n\tleft: 0px;\r\n\tright: 0px;\r\n\tpadding-bottom: 0px;\r\n\ttransform: translateY(-50%);\r\n\tz-index: 2;\r\n}\r\n\r\n.slider .carousel-caption .white-box {\r\n\tbackground-color: rgba(255, 255, 255, 0.7);\r\n\tmargin: auto;\r\n\tcolor: #333;\r\n\tposition: relative;\r\n\tborder-radius: 6px;\r\n\tpadding: 20px 20px;\r\n\tborder: 2px solid #00bcd4;\r\n}\r\n\r\n.slider .carousel-caption p a {\r\n\tborder-radius: 4px;\r\n\tbackground-color: #00bcd4;\r\n\tborder: 0px;\r\n\tcolor: #fff;\r\n\ttext-transform: uppercase;\r\n\tfont-size: 14px;\r\n\tfont-weight: 700;\r\n\tpadding: 8px 24px;\r\n}\r\n\r\n/* ===================================\r\n\t04. Feature area\r\n=================================== */\r\n.feature-box {\r\n\tbackground-color: #dffbff;\r\n\tposition: relative;\r\n\tborder-radius: 6px;\r\n\tpadding: 20px 20px;\r\n\ttext-align: center;\r\n\tborder: 2px solid rgba(0, 0, 0, 0.1);\r\n\tz-index: 0;\r\n\t-webkit-transition: all 0.3s ease-in-out;\r\n\t-moz-transition: all 0.3s ease-in-out;\r\n\t-o-transition: all 0.3s ease-in-out;\r\n\ttransition: all 0.3s ease-in-out;\r\n}\r\n\r\n.feature-box:after {\r\n\twidth: 0px;\r\n\theight: 0px;\r\n\tcontent: \"\";\r\n\tposition: absolute;\r\n\ttop: 50%;\r\n\tleft: 0px;\r\n\tright: 0px;\r\n\tmargin: auto;\r\n\tbackground-color: #00e1ff;\r\n\ttransform: translateY(-50%);\r\n\tborder-radius: 0%;\r\n\topacity: 0.2;\r\n\tz-index: -1;\r\n\t-webkit-transition: all 0.5s ease-in-out;\r\n\t-moz-transition: all 0.5s ease-in-out;\r\n\t-o-transition: all 0.5s ease-in-out;\r\n\ttransition: all 0.5s ease-in-out;\r\n}\r\n\r\n.feature-box:hover:after {\r\n\twidth: 100%;\r\n\theight: 100%;\r\n}\r\n\r\n.feature-box:hover {\r\n\tborder: 2px solid #00cee9;\r\n}\r\n\r\n.feature-box .icon {\r\n\tcolor: #333;\r\n\tmargin-bottom: 10px;\r\n\tfont-size: 35px;\r\n\t-webkit-transition: all 0.3s ease-in-out;\r\n\t-moz-transition: all 0.3s ease-in-out;\r\n\t-o-transition: all 0.3s ease-in-out;\r\n\ttransition: all 0.3s ease-in-out;\r\n}\r\n\r\n.feature-box:hover .icon {\r\n\tcolor: #00bcd4;\r\n}\r\n\r\n.feature-box h4 {\r\n\tmargin-bottom: 2px;\r\n}\r\n\r\n/* ===================================\r\n\t05. Counter area\r\n=================================== */\r\n.single-counter-box {\r\n\tposition: relative;\r\n\ttext-align: center;\r\n}\r\n\r\n.single-counter-box .icon-wrap {\r\n\twidth: 90px;\r\n\theight: 90px;\r\n\ttext-align: center;\r\n\tline-height: 90px;\r\n\tmargin: auto auto 20px auto;\r\n\tcolor: #fff;\r\n\tborder: 2px solid rgba(0, 0, 0, 0.1);\r\n\tborder-radius: 6px;\r\n\tbackground-color: #00bcd4;\r\n\tfont-size: 24px;\r\n\tposition: relative;\r\n\t-webkit-transition: all 0.3s ease-in-out;\r\n\t-moz-transition: all 0.3s ease-in-out;\r\n\t-o-transition: all 0.3s ease-in-out;\r\n\ttransition: all 0.3s ease-in-out;\r\n}\r\n\r\n.single-counter-box .text-wrap .counter-info-text span {\r\n\tcolor: #202020;\r\n\tfont-weight: 600;\r\n\tfont-size: 50px;\r\n\tline-height: 50px;\r\n\tmargin-bottom: 10px;\r\n\tdisplay: inline-block;\r\n}\r\n\r\n.single-counter-box .text-wrap h4 {\r\n\tcolor: #6c757d;\r\n\tfont-weight: 400;\r\n\tfont-size: 16px;\r\n\twhite-space: nowrap;\r\n}\r\n\r\n/* ===================================\r\n\t06. Services\r\n=================================== */\r\n.services-item {\r\n\tbackground-color: rgba(255, 255, 255, 1);\r\n\tposition: relative;\r\n\tborder-radius: 6px;\r\n\tpadding: 20px 20px;\r\n\tborder: 2px solid rgba(0, 0, 0, 0.1);\r\n\tz-index: 0;\r\n\t-webkit-transition: all 0.3s ease-in-out;\r\n\t-moz-transition: all 0.3s ease-in-out;\r\n\t-o-transition: all 0.3s ease-in-out;\r\n\ttransition: all 0.3s ease-in-out;\r\n}\r\n\r\n.services-item .icon-box {\r\n\tcolor: #00bcd4;\r\n\tmargin-bottom: 20px;\r\n\tline-height: 20px;\r\n\tfont-size: 40px;\r\n\t-webkit-transition: all 0.3s ease-in-out;\r\n\t-moz-transition: all 0.3s ease-in-out;\r\n\t-o-transition: all 0.3s ease-in-out;\r\n\ttransition: all 0.3s ease-in-out;\r\n}\r\n\r\n.services-item h4 {\r\n\tmargin-bottom: 20px;\r\n\t-webkit-transition: all 0.3s ease-in-out;\r\n\t-moz-transition: all 0.3s ease-in-out;\r\n\t-o-transition: all 0.3s ease-in-out;\r\n\ttransition: all 0.3s ease-in-out;\r\n}\r\n\r\n.services-item p {\r\n\t-webkit-transition: all 0.3s ease-in-out;\r\n\t-moz-transition: all 0.3s ease-in-out;\r\n\t-o-transition: all 0.3s ease-in-out;\r\n\ttransition: all 0.3s ease-in-out;\r\n}\r\n\r\n.services-item a {\r\n\tposition: absolute;\r\n\ttop: 20px;\r\n\tright: 20px;\r\n\tdisplay: inline-block;\r\n\twidth: 40px;\r\n\theight: 40px;\r\n\tfont-size: 16px;\r\n\ttext-align: center;\r\n\tline-height: 40px;\r\n\tbackground-color: #f5f5f5;\r\n\tcolor: #202020;\r\n\tborder-radius: 4px;\r\n\tbox-shadow: 0 8px 20px hsla(0, 0%, 0%, 0.13);\r\n}\r\n\r\n.services-item:hover {\r\n\tbackground-color: #00bcd4;\r\n\tborder: 2px solid #00bcd4;\r\n}\r\n\r\n.services-item:hover .icon-box,\r\n.services-item:hover h4,\r\n.services-item:hover p {\r\n\tcolor: #fff;\r\n}\r\n\r\n/* service link sidebar */\r\n.service-link {\r\n\tbackground-color: #00bcd4;\r\n\tborder-radius: 6px;\r\n\tpadding: 30px;\r\n\tmargin-bottom: 0px;\r\n}\r\n\r\n.service-link li {\r\n\tborder-bottom: 1px solid rgba(255, 255, 255, 0.2);\r\n\tmargin-bottom: 12px;\r\n\tpadding-bottom: 12px;\r\n}\r\n\r\n.service-link li a {\r\n\ttext-decoration: none;\r\n\tcolor: #fff;\r\n\tpadding-left: 16px;\r\n\tfont-size: 14px;\r\n\tdisplay: inline-block;\r\n\tposition: relative;\r\n\t-webkit-transition: all 0.3s ease-in-out;\r\n\t-moz-transition: all 0.3s ease-in-out;\r\n\t-o-transition: all 0.3s ease-in-out;\r\n\ttransition: all 0.3s ease-in-out;\r\n}\r\n\r\n.service-link li:last-child {\r\n\tborder-bottom: 0px;\r\n\tmargin-bottom: 0px;\r\n}\r\n\r\n.service-link li:last-child {\r\n\tpadding-bottom: 0px;\r\n}\r\n\r\n.service-link li a:hover {\r\n\tcolor: #333;\r\n}\r\n\r\n.service-link li a:before {\r\n\tdisplay: inline-block;\r\n\twidth: 0;\r\n\theight: 0;\r\n\tleft: 0px;\r\n\ttop: 50%;\r\n\tposition: absolute;\r\n\tmargin-left: 0;\r\n\tcontent: \"\";\r\n\tborder-top: .3em solid transparent;\r\n\tborder-bottom: .3em solid transparent;\r\n\tborder-right: 0;\r\n\tborder-left: .3em solid;\r\n\ttransform: translateY(-50%);\r\n}\r\n\r\n/* download brochure */\r\n.download-brochure a {\r\n\tbackground-color: #00bcd4;\r\n\ttext-decoration: none;\r\n\tborder-radius: 6px;\r\n\tdisplay: inline-block;\r\n\toverflow: hidden;\r\n\tcolor: #fff;\r\n\twidth: 100%;\r\n\tfont-size: 14px;\r\n}\r\n\r\n.download-brochure a i {\r\n\tbackground-color: #018fa2;\r\n\tpadding: 20px 16px;\r\n\tmargin-right: 10px;\r\n}\r\n\r\n/* service contant img */\r\n.service-contant-img img {\r\n\tborder: 2px solid rgba(0, 0, 0, 0.1);\r\n\tborder-radius: 6px;\r\n\tpadding: 6px;\r\n}\r\n\r\n/* blockquote */\r\n.service-detail-contant blockquote {\r\n\tborder: 0px;\r\n\tbackground-color: #202020;\r\n\tpadding: 30px;\r\n\tborder-radius: 6px;\r\n\tmargin-bottom: 0px;\r\n}\r\n\r\n.service-detail-contant blockquote p {\r\n\tcolor: #fff;\r\n\tfont-style: italic;\r\n\tfont-size: 16px;\r\n\tline-height: 28px;\r\n}\r\n\r\n.service-detail-contant blockquote .blockquote-footer {\r\n\tmargin-top: 10px;\r\n\tcolor: #00bcd4;\r\n\tfont-size: 12px;\r\n}\r\n\r\n/* ===================================\r\n\t07. Testimonials\r\n=================================== */\r\n.testimonial-area {\r\n\tbackground-image: url(../img/bg/testimonial-bg.jpg);\r\n\tbackground-size: cover;\r\n\tbackground-position: center top;\r\n\tposition: relative;\r\n}\r\n\r\n.testimonial-area:after {\r\n\tposition: absolute;\r\n\tcontent: \"\";\r\n\tbackground-color: rgba(0, 0, 0, 0.7);\r\n\twidth: 100%;\r\n\theight: 100%;\r\n\tleft: 0px;\r\n\ttop: 0px;\r\n}\r\n\r\n.testimonial-item p {\r\n\ttext-align: center;\r\n\tcolor: #fff;\r\n\tfont-style: italic;\r\n\tpadding-top: 35px;\r\n\tmargin-bottom: 0px;\r\n\tborder-top: 2px solid rgba(255, 255, 255, 0.2);\r\n}\r\n\r\n.testimonial-item .position {\r\n\tcolor: #00bcd4;\r\n\ttext-transform: uppercase;\r\n\tfont-size: 12px;\r\n\tfont-weight: 600;\r\n\tpadding-bottom: 6px;\r\n}\r\n\r\n.testimonial-item .testimonial-client-img {\r\n\tcolor: #fff;\r\n\tborder-radius: 50px;\r\n\tpadding: 0px;\r\n\theight: 100px;\r\n\twidth: 100px;\r\n\tmargin: 35px auto auto auto;\r\n\tdisplay: inline-block;\r\n}\r\n\r\n.testimonial-item .testimonial-client-img img {\r\n\tborder: 2px solid rgba(0, 0, 0, 0.1);\r\n\tborder-radius: 6px;\r\n}\r\n\r\n.testimonial-item .testimonial-line {\r\n\twidth: 100%;\r\n\ttext-align: center;\r\n\tposition: relative;\r\n}\r\n\r\n.testimonial-item .testimonial-line:after {\r\n\tbackground-color: rgba(255, 255, 255, 0.2);\r\n\tcontent: \"\";\r\n\tdisplay: block;\r\n\theight: 2px;\r\n\tleft: 0;\r\n\tmargin-top: 17px;\r\n\tposition: absolute;\r\n\tright: 0;\r\n\ttop: 50%;\r\n\ttransform: translateY(-50%);\r\n\twidth: 100%;\r\n\tz-index: -1;\r\n}\r\n\r\n.testimonial-item .testimonial-client {\r\n\twidth: 100%;\r\n\tmargin: 10px 0 0 0px;\r\n}\r\n\r\n.testimonial-item .testimonial-client h6 {\r\n\tmargin-bottom: 0px;\r\n\tcolor: #fff;\r\n\ttext-transform: uppercase;\r\n}\r\n\r\n.testimonial-item .testimonial-client p {\r\n\tfont-size: 13px;\r\n\tfont-weight: 500;\r\n\tcolor: #fff;\r\n\tmargin-bottom: 0px;\r\n}\r\n\r\n.testimonial-item .testimonial-info {\r\n\tmargin: 0 auto;\r\n\toverflow: hidden;\r\n\ttext-align: center;\r\n}\r\n\r\n.testimonial-carousel .owl-nav button {\r\n\twidth: 40px;\r\n\theight: 40px;\r\n\tfont-size: 16px;\r\n\ttext-align: center;\r\n\tcolor: #202020 !important;\r\n\tborder-radius: 4px;\r\n\tmargin: 15px 4px 0 4px !important;\r\n\tbackground-color: #f5f5f5 !important;\r\n\t-webkit-transition: all 0.3s ease-in-out;\r\n\t-moz-transition: all 0.3s ease-in-out;\r\n\t-o-transition: all 0.3s ease-in-out;\r\n\ttransition: all 0.3s ease-in-out;\r\n}\r\n\r\n.testimonial-carousel .owl-nav button:hover {\r\n\tbackground-color: #00bcd4 !important;\r\n\tcolor: #fff !important;\r\n}\r\n\r\n/* ===================================\r\n\t08. Team\r\n=================================== */\r\n.team-item {\r\n\tposition: relative;\r\n\tborder-radius: 10px;\r\n\tborder: 2px solid rgba(0, 0, 0, 0.1);\r\n\toverflow: hidden;\r\n\t-webkit-transition: all 0.3s ease-in-out;\r\n\t-moz-transition: all 0.3s ease-in-out;\r\n\t-o-transition: all 0.3s ease-in-out;\r\n\ttransition: all 0.3s ease-in-out;\r\n}\r\n\r\n.team-item:hover {\r\n\tborder: 2px solid #00bcd4;\r\n}\r\n\r\n.team-item .team-info {\r\n\tpadding: 10px 50px 10px 15px;\r\n\tposition: absolute;\r\n\tleft: 0px;\r\n\tbottom: 0px;\r\n\tborder-radius: 0px 6px 6px 0px;\r\n\tdisplay: inline-block;\r\n\tbackground-color: #202020;\r\n\tclip-path: polygon(0% 0%, 100% 0%, 80% 100%, 0% 100%);\r\n\t-webkit-transition: all 0.3s ease-in-out;\r\n\t-moz-transition: all 0.3s ease-in-out;\r\n\t-o-transition: all 0.3s ease-in-out;\r\n\ttransition: all 0.3s ease-in-out;\r\n}\r\n\r\n.team-item:hover .team-info {\r\n\tbackground-color: #00bcd4;\r\n}\r\n\r\n.team-item .team-info h5 a {\r\n\tcolor: #fff;\r\n\tfont-size: 16px;\r\n\tdisplay: inline-block;\r\n\tmargin-bottom: 4px;\r\n\ttext-transform: uppercase;\r\n}\r\n\r\n.team-item .team-info h6 {\r\n\tcolor: #fff;\r\n\tfont-size: 11px;\r\n\ttext-transform: uppercase;\r\n\tfont-weight: 600;\r\n}\r\n\r\n/* Media Query pour les écrans de moins de 768px */\r\n\r\n@media (max-width: 768px) {\r\n\t.team-item .team-info h5 a {\r\n\r\n\t\tfont-size: 14px;\r\n\t\t/* Réduit la taille de la police à 14px sur les petits écrans */\r\n\t}\r\n\r\n\t.team-item .team-info h6 {\r\n\r\n\t\tfont-size: 9px;\r\n\t\t/* Réduit la taille de la police à 14px sur les petits écrans */\r\n\t}\r\n}\r\n\r\n/* Media Query pour les écrans de moins de 576px */\r\n@media (max-width: 576px) {\r\n\t.team-item .team-info h5 a {\r\n\r\n\t\tfont-size: 12px;\r\n\t\t/* Réduit encore la taille de la police à 12px sur les très petits écrans */\r\n\t}\r\n\r\n\t.team-item .team-info h6 {\r\n\r\n\t\tfont-size: 7px;\r\n\t\t/* Réduit la taille de la police à 14px sur les petits écrans */\r\n\t}\r\n}\r\n\r\n.team-social {\r\n\tposition: absolute;\r\n\ttop: 0px;\r\n\tright: 0px;\r\n\tbackground-color: #00bcd4;\r\n}\r\n\r\n.team-social li a {\r\n\twidth: 40px;\r\n\theight: 40px;\r\n\ttext-align: center;\r\n\tline-height: 40px;\r\n\tcolor: #fff;\r\n\tborder-bottom: 1px solid rgba(255, 255, 255, 0.2);\r\n\tbackground-color: #00bcd4;\r\n\tdisplay: inline-block;\r\n\tfont-size: 14px;\r\n\t-webkit-transition: all 0.3s ease-in-out;\r\n\t-moz-transition: all 0.3s ease-in-out;\r\n\t-o-transition: all 0.3s ease-in-out;\r\n\ttransition: all 0.3s ease-in-out;\r\n}\r\n\r\n.team-social li:last-child a {\r\n\tborder-bottom: 0px;\r\n}\r\n\r\n.team-social li a:hover {\r\n\tbackground-color: #018fa2;\r\n}\r\n\r\n/* ===================================\r\n\t08.5 Carte membre\r\n=================================== */\r\n.RolePresident{\r\n\tclip-path: polygon(10% 0%, 90% 0%, 80% 100%, 20% 100%);\r\n\tbackground-color: #00bcd4;\r\n\tfont-size: 12px; /* Ajuste la taille de la police ici */\r\n}\r\n\r\n.RoleMembre{\r\n\tclip-path: polygon(10% 0%, 90% 0%, 80% 100%, 20% 100%);\r\n\tbackground-color: #00d4b1;\r\n\tfont-size: 12px; /* Ajuste la taille de la police ici */\r\n}\r\n\r\n\r\n/* ===================================\r\n\t09. Call to action\r\n=================================== */\r\n.call-to-action-area {\r\n\tbackground-image: url(../img/bg/call-to-action-bg.jpg);\r\n\tbackground-size: cover;\r\n\tbackground-position: center top;\r\n\tposition: relative;\r\n\ttext-align: center;\r\n\tz-index: 0;\r\n}\r\n\r\n.call-to-action-area:after {\r\n\tposition: absolute;\r\n\tcontent: \"\";\r\n\tbackground-color: rgba(0, 0, 0, 0.7);\r\n\twidth: 100%;\r\n\theight: 100%;\r\n\tleft: 0px;\r\n\ttop: 0px;\r\n\tz-index: -1;\r\n}\r\n\r\n.cta-content h3 {\r\n\tfont-size: 18px;\r\n\tcolor: #00bcd4;\r\n\tfont-weight: 400;\r\n\tmargin-bottom: 20px;\r\n}\r\n\r\n.call-to-action-area h2 {\r\n\tcolor: #fff;\r\n\tfont-weight: 700;\r\n\tfont-size: 40px;\r\n\tline-height: 44px;\r\n\tmargin-bottom: 20px;\r\n}\r\n\r\n.call-to-action-area h2 a {\r\n\tcolor: #fff;\r\n\ttext-decoration: underline;\r\n}\r\n\r\n.call-to-action-area p {\r\n\tcolor: #fff;\r\n\tline-height: 28px;\r\n}\r\n\r\n.video-popup {\r\n\tposition: relative;\r\n\tdisplay: inline-block;\r\n\twidth: 80px;\r\n\theight: 80px;\r\n\tline-height: 80px;\r\n\tcolor: #fff;\r\n\tfont-size: 24px;\r\n\tmargin-bottom: 30px;\r\n\tborder-radius: 100%;\r\n\tbackground-color: #00bcd4;\r\n}\r\n\r\n.video-popup:before {\r\n\tposition: absolute;\r\n\tcontent: '';\r\n\twidth: 100%;\r\n\theight: 100%;\r\n\tbackground: #00bcd4;\r\n\tborder-radius: 100%;\r\n\ttop: 0;\r\n\tanimation-fill-mode: both;\r\n\tanimation: witr_squares 1.5s ease-in-out infinite;\r\n\tleft: 0;\r\n\tright: 0;\r\n\tbottom: 0;\r\n\tz-index: 0;\r\n}\r\n\r\n.video-popup:after {\r\n\tposition: absolute;\r\n\tcontent: '';\r\n\twidth: 90px;\r\n\theight: 90px;\r\n\tborder: 2px solid #00bcd4;\r\n\tborder-radius: 100%;\r\n\ttop: -5px;\r\n\tleft: -5px;\r\n\tright: 0;\r\n\tbottom: 0;\r\n\tz-index: 0;\r\n}\r\n\r\n.video-popup i {\r\n\tz-index: 2;\r\n\tposition: relative;\r\n}\r\n\r\n.video-popup:hover {\r\n\tcolor: #fff;\r\n}\r\n\r\n/* witr_squares_ */\r\n@keyframes witr_squares {\r\n\t0% {\r\n\t\ttransform: scale(1);\r\n\t\topacity: 0\r\n\t}\r\n\r\n\t20% {\r\n\t\ttransform: scale(1.24);\r\n\t\topacity: 1\r\n\t}\r\n\r\n\t100% {\r\n\t\ttransform: scale(2.1);\r\n\t\topacity: 0\r\n\t}\r\n}\r\n\r\n/* ===================================\r\n\t10. Blog\r\n=================================== */\r\n.blog-item {\r\n\tposition: relative;\r\n\tborder-radius: 6px;\r\n\tborder: 2px solid rgba(0, 0, 0, 0.1);\r\n\toverflow: hidden;\r\n\t-webkit-transition: all 0.3s ease-in-out;\r\n\t-moz-transition: all 0.3s ease-in-out;\r\n\t-o-transition: all 0.3s ease-in-out;\r\n\ttransition: all 0.3s ease-in-out;\r\n}\r\n\r\n.blog-item:hover {\r\n\tborder: 2px solid #00bcd4;\r\n}\r\n\r\n.blog-item .blog-content-area {\r\n\tpadding: 20px;\r\n}\r\n\r\n.blog-item .blog-meta {\r\n\tmargin-bottom: 10px;\r\n}\r\n\r\n.blog-item .blog-meta li {\r\n\tposition: relative;\r\n\tfont-size: 12px;\r\n\tcolor: #202020;\r\n\tmargin-right: 16px !important;\r\n}\r\n\r\n.blog-item .blog-meta li a {\r\n\tcolor: #202020;\r\n\t-webkit-transition: all 0.3s ease-in-out;\r\n\t-moz-transition: all 0.3s ease-in-out;\r\n\t-o-transition: all 0.3s ease-in-out;\r\n\ttransition: all 0.3s ease-in-out;\r\n}\r\n\r\n.blog-item .blog-meta li a:hover {\r\n\tcolor: #00bcd4;\r\n}\r\n\r\n.blog-item .blog-meta li:after {\r\n\tposition: absolute;\r\n\tcontent: \"/\";\r\n\ttop: 50%;\r\n\tfont-size: 10px;\r\n\tright: -12px;\r\n\ttransform: translateY(-50%);\r\n}\r\n\r\n.blog-item .blog-meta li:last-child {\r\n\tmargin-right: 0px !important;\r\n}\r\n\r\n.blog-item .blog-meta li:last-child:after {\r\n\tdisplay: none;\r\n}\r\n\r\n.blog-item h4 {\r\n\tline-height: 24px;\r\n\tmargin-bottom: 10px;\r\n}\r\n\r\n.blog-item h4 a {\r\n\tcolor: #202020;\r\n\tfont-size: 18px;\r\n\t-webkit-transition: all 0.3s ease-in-out;\r\n\t-moz-transition: all 0.3s ease-in-out;\r\n\t-o-transition: all 0.3s ease-in-out;\r\n\ttransition: all 0.3s ease-in-out;\r\n}\r\n\r\n.blog-item h4 a:hover {\r\n\tcolor: #00bcd4;\r\n}\r\n\r\n.blog-item .blog-thumb {\r\n\tposition: relative;\r\n}\r\n\r\n.blog-item .blog-thumb:after {\r\n\tposition: absolute;\r\n\tcontent: \"\";\r\n\twidth: 0;\r\n\theight: 0;\r\n\tbackground-color: rgba(0, 0, 0, 0.3);\r\n\ttop: 0px;\r\n\topacity: 0;\r\n\tleft: 0px;\r\n\tright: 0px;\r\n\tmargin: auto;\r\n\tz-index: 0;\r\n\t-webkit-transition: all 0.3s ease-in-out;\r\n\t-moz-transition: all 0.3s ease-in-out;\r\n\t-o-transition: all 0.3s ease-in-out;\r\n\ttransition: all 0.3s ease-in-out;\r\n}\r\n\r\n.blog-item:hover .blog-thumb:after {\r\n\twidth: 100%;\r\n\theight: 100%;\r\n\topacity: 1;\r\n}\r\n\r\n.blog-item .blog-thumb a {\r\n\tposition: absolute;\r\n\ttop: 20px;\r\n\tright: 20px;\r\n\tdisplay: inline-block;\r\n\twidth: 40px;\r\n\theight: 40px;\r\n\tfont-size: 16px;\r\n\ttext-align: center;\r\n\tline-height: 40px;\r\n\tbackground-color: #f5f5f5;\r\n\tcolor: #202020;\r\n\tborder-radius: 4px;\r\n\tbox-shadow: 0 8px 20px hsla(0, 0%, 0%, 0.13);\r\n\tz-index: 1;\r\n}\r\n\r\n/* singal post img */\r\n.singal-blog-post {\r\n\tborder: 2px solid rgba(0, 0, 0, 0.1);\r\n\tborder-radius: 6px;\r\n\toverflow: hidden;\r\n}\r\n\r\n/* blog meta */\r\n.singal-blog-post .singal-blog-meta {\r\n\tmargin-bottom: 10px;\r\n}\r\n\r\n.singal-blog-post .singal-blog-meta li {\r\n\tposition: relative;\r\n\tfont-size: 12px;\r\n\tcolor: #202020;\r\n\tpadding-bottom: 0px;\r\n\tmargin-right: 16px !important;\r\n}\r\n\r\n.singal-blog-post .singal-blog-meta li a {\r\n\tcolor: #202020;\r\n\t-webkit-transition: all 0.3s ease-in-out;\r\n\t-moz-transition: all 0.3s ease-in-out;\r\n\t-o-transition: all 0.3s ease-in-out;\r\n\ttransition: all 0.3s ease-in-out;\r\n}\r\n\r\n.singal-blog-post .singal-blog-meta li a:hover {\r\n\tcolor: #00bcd4;\r\n}\r\n\r\n.singal-blog-post .singal-blog-meta li:after {\r\n\tposition: absolute;\r\n\tcontent: \"/\";\r\n\ttop: 50%;\r\n\tfont-size: 10px;\r\n\tright: -12px;\r\n\ttransform: translateY(-50%);\r\n}\r\n\r\n.singal-blog-post .singal-blog-meta li:last-child {\r\n\tmargin-right: 0px !important;\r\n}\r\n\r\n.singal-blog-post .singal-blog-meta li:last-child:after {\r\n\tdisplay: none;\r\n}\r\n\r\n/* blockquote */\r\n.singal-blog-post blockquote {\r\n\tborder: 0px;\r\n\tpadding: 10px 30px;\r\n\tborder-left: 2px solid #00bcd4;\r\n\tmargin-bottom: 20px;\r\n}\r\n\r\n.singal-blog-post blockquote p {\r\n\tcolor: #333;\r\n\tfont-style: italic;\r\n\tfont-size: 16px;\r\n\tline-height: 28px;\r\n}\r\n\r\n.singal-blog-post blockquote .blockquote-footer {\r\n\tmargin-top: 10px;\r\n\tcolor: #00bcd4;\r\n\tfont-size: 12px;\r\n}\r\n\r\n.singal-blog-post ul li i {\r\n\tcolor: #00bcd4;\r\n\tpadding-right: 8px;\r\n}\r\n\r\n.singal-blog-post ul li {\r\n\tcolor: #6c757d;\r\n\tfont-size: 14px;\r\n\tpadding-bottom: 14px;\r\n}\r\n\r\n.singal-blog-post ul li:last-child {\r\n\tpadding-bottom: 0px;\r\n}\r\n\r\n/* social block */\r\n.social-block {\r\n\tborder-top: 1px solid rgba(0, 0, 0, 0.1);\r\n\tpadding: 20px 0 0px 0;\r\n}\r\n\r\n.singal-blog-post .tags-post a {\r\n\tfont-size: 12px;\r\n\tcolor: #6c757d;\r\n\ttext-decoration: none;\r\n\tpadding: 4px 12px;\r\n\tposition: relative;\r\n\t-webkit-transition: all 0.3s ease-in-out;\r\n\t-moz-transition: all 0.3s ease-in-out;\r\n\t-o-transition: all 0.3s ease-in-out;\r\n\ttransition: all 0.3s ease-in-out;\r\n}\r\n\r\n.singal-blog-post .tags-post a:after {\r\n\tposition: absolute;\r\n\tcontent: \"/\";\r\n\ttop: 50%;\r\n\tfont-size: 10px;\r\n\ttransform: translateY(-50%);\r\n\tright: -2px;\r\n}\r\n\r\n.singal-blog-post .tags-post a:first-child {\r\n\tpadding-left: 0px;\r\n}\r\n\r\n.singal-blog-post .tags-post a:last-child {\r\n\tpadding-right: 0px;\r\n}\r\n\r\n.singal-blog-post .tags-post a:last-child:after {\r\n\tdisplay: none;\r\n}\r\n\r\n.singal-blog-post .tags-post a:hover {\r\n\tcolor: #00bcd4;\r\n}\r\n\r\n.singal-blog-post .share-social a {\r\n\tfont-size: 12px;\r\n\tbackground-color: #6c757d;\r\n\tcolor: #fff;\r\n\ttext-decoration: none;\r\n\twidth: 30px;\r\n\theight: 30px;\r\n\tline-height: 30px;\r\n\ttext-align: center;\r\n\tdisplay: inline-block;\r\n\tborder-radius: 100%;\r\n\t-webkit-transition: all 0.3s ease-in-out;\r\n\t-moz-transition: all 0.3s ease-in-out;\r\n\t-o-transition: all 0.3s ease-in-out;\r\n\ttransition: all 0.3s ease-in-out;\r\n}\r\n\r\n.singal-blog-post .share-social a:hover {\r\n\tbackground-color: #00bcd4;\r\n}\r\n\r\n/* comments box */\r\n.comments-box {\r\n\twidth: 100%;\r\n\tpadding-bottom: 30px;\r\n\tdisplay: inline-block;\r\n\tmargin-bottom: 30px;\r\n\tborder-bottom: 1px solid rgba(0, 0, 0, 0.1);\r\n}\r\n\r\n.comments-box:last-child {\r\n\tpadding-bottom: 0px;\r\n\tmargin-bottom: 0px;\r\n\tborder-bottom: 0px;\r\n}\r\n\r\n.comments-box .img-wrapper {\r\n\tfloat: left;\r\n\twidth: 100px;\r\n}\r\n\r\n.comments-box .img-wrapper img {\r\n\tborder: 3px solid #fff;\r\n\t-webkit-border-radius: 100%;\r\n\t-moz-border-radius: 100%;\r\n\tborder-radius: 100%;\r\n\t-webkit-transition: all 0.3s ease-in-out;\r\n\t-moz-transition: all 0.3s ease-in-out;\r\n\t-o-transition: all 0.3s ease-in-out;\r\n\ttransition: all 0.3s ease-in-out;\r\n}\r\n\r\n.comments-box .text-wrapper {\r\n\tfloat: left;\r\n\twidth: calc(100% - 100px);\r\n\tpadding-left: 30px;\r\n}\r\n\r\n.author-detail {\r\n\tmargin-bottom: 10px;\r\n}\r\n\r\n.author-detail .author-name {\r\n\tfont-size: 18px;\r\n\tcolor: #00bcd4;\r\n}\r\n\r\n.author-detail .publish-date {\r\n\tfont-size: 12px;\r\n\tmargin-left: 8px;\r\n\tcolor: #999;\r\n}\r\n\r\n.author-content a {\r\n\tcolor: #00bcd4;\r\n\tfont-size: 12px;\r\n\ttext-transform: uppercase;\r\n}\r\n\r\n.author-content a i {\r\n\tcolor: #00bcd4;\r\n\tfont-size: 14px;\r\n\tmargin-left: 5px;\r\n}\r\n\r\n.comments-box:hover .img-wrapper img {\r\n\tborder: 3px solid #00bcd4;\r\n}\r\n\r\n/* comments form */\r\n.comments-form input {\r\n\tbackground-color: #fff;\r\n\tborder: 1px solid rgba(0, 0, 0, 0.1);\r\n\tborder-radius: 6px;\r\n\tfont-size: 14px;\r\n\theight: 50px;\r\n}\r\n\r\n.comments-form textarea {\r\n\tbackground-color: #fff;\r\n\tborder: 1px solid rgba(0, 0, 0, 0.1);\r\n\tborder-radius: 6px;\r\n\tfont-size: 14px;\r\n}\r\n\r\n.comments-form .form-control:focus {\r\n\tbox-shadow: none;\r\n\tborder: 2px solid #00bcd4;\r\n}\r\n\r\n/* ===================================\r\n\t11. Footer\r\n=================================== */\r\n.footer {\r\n\tbackground-color: #202020;\r\n}\r\n\r\n.footer-about {\r\n\ttext-align: center;\r\n}\r\n\r\n/* footer social */\r\n.footer-social a {\r\n\twidth: 40px;\r\n\theight: 40px;\r\n\tline-height: 40px;\r\n\ttext-align: center;\r\n\tborder-radius: 100%;\r\n\tcolor: #fff;\r\n\tbackground-color: #2d2d2d;\r\n\tdisplay: inline-block;\r\n\t-webkit-transition: all 0.3s ease-in-out;\r\n\t-moz-transition: all 0.3s ease-in-out;\r\n\t-o-transition: all 0.3s ease-in-out;\r\n\ttransition: all 0.3s ease-in-out;\r\n}\r\n\r\n.footer-social a:hover {\r\n\tbackground-color: #00bcd4;\r\n}\r\n\r\n/* footer contact */\r\n.footer-contact {\r\n\tborder-top: 1px solid rgba(255, 255, 255, 0.1);\r\n\tpadding-top: 30px;\r\n\tmargin-top: 30px;\r\n\tmargin-bottom: 15px;\r\n}\r\n\r\n.footer-contact li {\r\n\tmargin: 0px 30px 0px 0px !important;\r\n}\r\n\r\n.footer-contact li:last-child {\r\n\tmargin: 0px 0px 0px 0px !important;\r\n}\r\n\r\n.footer-contact li,\r\n.footer-contact li a {\r\n\tcolor: #6c757d;\r\n\tfont-size: 14px;\r\n\t-webkit-transition: all 0.3s ease-in-out;\r\n\t-moz-transition: all 0.3s ease-in-out;\r\n\t-o-transition: all 0.3s ease-in-out;\r\n\ttransition: all 0.3s ease-in-out;\r\n}\r\n\r\n.footer-contact li {\r\n\tpadding-bottom: 15px;\r\n}\r\n\r\n.footer-contact li i {\r\n\tpadding-right: 6px;\r\n}\r\n\r\n.footer-contact li a:hover {\r\n\tcolor: #00bcd4;\r\n}\r\n\r\n/* footer bottom */\r\n.footer-bottom {\r\n\tborder-top: 1px solid rgba(255, 255, 255, 0.1);\r\n\tpadding-top: 30px;\r\n\tpadding-bottom: 20px;\r\n\tbackground-color: #181818;\r\n}\r\n\r\n/* footer link */\r\n.footer-link li {\r\n\tmargin: 0px 20px 0px 0px !important;\r\n}\r\n\r\n.footer-link li:last-child {\r\n\tmargin: 0px 0px 0px 0px !important;\r\n}\r\n\r\n.footer-link li a {\r\n\tcolor: #6c757d;\r\n\tfont-size: 14px;\r\n\tdisplay: inline-block;\r\n\tpadding-bottom: 10px;\r\n\t-webkit-transition: all 0.3s ease-in-out;\r\n\t-moz-transition: all 0.3s ease-in-out;\r\n\t-o-transition: all 0.3s ease-in-out;\r\n\ttransition: all 0.3s ease-in-out;\r\n}\r\n\r\n.footer-link li a:hover {\r\n\tcolor: #00bcd4;\r\n}\r\n\r\n/* footer copyright */\r\n.footer-copyright {\r\n\tcolor: #6c757d;\r\n\tfont-size: 14px;\r\n\tmargin-bottom: 10px;\r\n}\r\n\r\n/* ===================================\r\n\t12. Inner page title\r\n=================================== */\r\n.inner-page-title-area {\r\n\tbackground-image: url(../img/bg/inner-page-title-bg.jpg);\r\n\tbackground-repeat: no-repeat;\r\n\tbackground-position: center top;\r\n\ttext-align: center;\r\n\tbackground-size: cover;\r\n\tpadding: 220px 0px;\r\n\tposition: relative;\r\n\tz-index: 0;\r\n}\r\n\r\n.inner-page-title-area:after {\r\n\tbackground-color: rgba(0, 0, 0, 0.6);\r\n\tposition: absolute;\r\n\twidth: 100%;\r\n\theight: 100%;\r\n\tcontent: \"\";\r\n\ttop: 0px;\r\n\tleft: 0px;\r\n\tz-index: -1;\r\n}\r\n\r\n.inner-page-title-area h1 {\r\n\tfont-weight: 600;\r\n\tfont-size: 36px;\r\n\tcolor: #fff;\r\n\tmargin-top: 20px;\r\n\tline-height: 24px;\r\n}\r\n\r\n.inner-page-title-area h1 span {\r\n\tposition: relative;\r\n}\r\n\r\n.inner-page-title-area h1 span:after {\r\n\tposition: absolute;\r\n\tcontent: \"\";\r\n\twidth: 1px;\r\n\theight: 94%;\r\n\tbackground-color: #00bcd4;\r\n\ttop: 50%;\r\n\tleft: -25px;\r\n\ttransform: translateY(-50%);\r\n}\r\n\r\n.inner-page-title-area h1 span:before {\r\n\tposition: absolute;\r\n\tcontent: \"\";\r\n\twidth: 1px;\r\n\theight: 94%;\r\n\tbackground-color: #00bcd4;\r\n\ttop: 50%;\r\n\tright: -25px;\r\n\ttransform: translateY(-50%);\r\n}\r\n\r\n.inner-page-title-area .breadcrumb {\r\n\tmargin: auto;\r\n\ttext-align: center;\r\n\tpadding: 0px;\r\n\tdisplay: inline-block;\r\n\tbackground-color: transparent;\r\n}\r\n\r\n.inner-page-title-area .breadcrumb li {\r\n\tfloat: none;\r\n\tcolor: #fff;\r\n\tdisplay: inline-block;\r\n}\r\n\r\n.inner-page-title-area .breadcrumb li a {\r\n\tcolor: #00bcd4;\r\n}\r\n\r\n.inner-page-title-area .breadcrumb-item+.breadcrumb-item:before {\r\n\tcolor: #fff;\r\n}\r\n\r\n/* ===================================\r\n\t13. Portfolio\r\n=================================== */\r\n#portfoliolist .portfolio {\r\n\t-webkit-box-sizing: border-box;\r\n\t-moz-box-sizing: border-box;\r\n\t-o-box-sizing: border-box;\r\n\tdisplay: none;\r\n}\r\n\r\n.filter1 {\r\n\tborder: 1px solid #eee;\r\n\tborder-radius: 30px;\r\n\tpadding: 10px;\r\n}\r\n\r\n.filter1 li {\r\n\tmargin-right: 0px !important;\r\n}\r\n\r\n.filter1 li span {\r\n\tcursor: pointer;\r\n\tpadding: 8px 12px 8px 12px;\r\n\tdisplay: inline-block;\r\n\tposition: relative;\r\n\tfont-size: 12px;\r\n\tfont-weight: 400;\r\n\tcolor: #fff;\r\n\tbackground-color: #202020;\r\n\tborder-radius: 30px;\r\n\ttext-transform: uppercase;\r\n\t-webkit-transition: all 0.3s ease-in-out;\r\n\t-moz-transition: all 0.3s ease-in-out;\r\n\t-o-transition: all 0.3s ease-in-out;\r\n\ttransition: all 0.3s ease-in-out;\r\n}\r\n\r\n.filter1 li span.active,\r\n.filter1 li span:hover {\r\n\tcolor: #fff;\r\n\tbackground-color: #00bcd4;\r\n}\r\n\r\n.portfolio-box {\r\n\tmargin-bottom: 30px;\r\n\tposition: relative;\r\n\tborder-radius: 6px;\r\n\tborder-bottom: 2px solid rgba(0, 0, 0, 0.1);\r\n\ttext-align: center;\r\n\toverflow: hidden;\r\n}\r\n\r\n.portfolio-box .portfolio-box-img {\r\n\tposition: relative;\r\n\toverflow: hidden;\r\n}\r\n\r\n.portfolio-box .portfolio-box-img .hoverlay {\r\n\theight: 100%;\r\n\tleft: 0;\r\n\tposition: absolute;\r\n\ttop: 0;\r\n\twidth: 100%;\r\n\tbackground-color: rgba(0, 0, 0, 0);\r\n\t-webkit-transition: all 0.5s ease-in-out;\r\n\t-moz-transition: all 0.5s ease-in-out;\r\n\t-o-transition: all 0.5s ease-in-out;\r\n\ttransition: all 0.5s ease-in-out;\r\n}\r\n\r\n.portfolio-box:hover .portfolio-box-img .hoverlay {\r\n\tbackground-color: rgba(0, 0, 0, 0.8);\r\n}\r\n\r\n.portfolio-box .readmore {\r\n\tcolor: #fff;\r\n\tfont-size: 12px;\r\n\tposition: absolute;\r\n\tright: 0px;\r\n\tleft: 0px;\r\n\tbackground-color: #00bcd4;\r\n\topacity: 0;\r\n\tmargin: auto;\r\n\ttop: 50%;\r\n\twidth: 40px;\r\n\theight: 40px;\r\n\ttext-align: center;\r\n\tborder-radius: 100%;\r\n\ttransform: translateY(-50%);\r\n\tline-height: 40px;\r\n\t-webkit-transition: all 0.3s ease-in-out;\r\n\t-moz-transition: all 0.3s ease-in-out;\r\n\t-o-transition: all 0.3s ease-in-out;\r\n\ttransition: all 0.3s ease-in-out;\r\n}\r\n\r\n.portfolio-box:hover .readmore {\r\n\topacity: 1;\r\n}\r\n\r\n.portfolio-box .hoverlay a:hover {\r\n\tcolor: #fff;\r\n}\r\n\r\n.portfolio-box h5 {\r\n\tcolor: #202020;\r\n\tfont-size: 16px;\r\n\tfont-weight: 600;\r\n\tpadding: 20px 0px;\r\n\t-webkit-transition: all 0.3s ease-in-out;\r\n\t-moz-transition: all 0.3s ease-in-out;\r\n\t-o-transition: all 0.3s ease-in-out;\r\n\ttransition: all 0.3s ease-in-out;\r\n}\r\n\r\n.portfolio-box:hover h5 {\r\n\tbackground-color: #00bcd4;\r\n\tcolor: #fff;\r\n}\r\n\r\n/* ===================================\r\n\t14. Contact form\r\n=================================== */\r\n/* contact form */\r\n.contact-form input {\r\n\tbackground-color: #fff;\r\n\tborder: 1px solid rgba(0, 0, 0, 0.1);\r\n\tborder-radius: 6px;\r\n\tfont-size: 14px;\r\n\theight: 50px;\r\n}\r\n\r\n.contact-form textarea {\r\n\tbackground-color: #fff;\r\n\tborder: 1px solid rgba(0, 0, 0, 0.1);\r\n\tborder-radius: 6px;\r\n\tfont-size: 14px;\r\n}\r\n\r\n.contact-form .form-control:focus {\r\n\tbox-shadow: none;\r\n\tborder: 2px solid #00bcd4;\r\n}\r\n\r\n.help-block.with-errors ul {\r\n\tcolor: #721c24;\r\n\tbackground-color: #f8d7da;\r\n\tborder-color: #f5c6cb;\r\n\tpadding: 10px;\r\n}\r\n\r\n/* contact info */\r\n.contact-info-item {\r\n\tmargin-bottom: 20px;\r\n\twidth: 100%;\r\n\tdisplay: inline-block;\r\n}\r\n\r\n.contact-info-item:last-child {\r\n\tmargin-bottom: 0px;\r\n}\r\n\r\n.contact-info-item .icon-box {\r\n\twidth: 40px;\r\n\tfloat: left;\r\n\tmargin-right: 5px;\r\n}\r\n\r\n.contact-info-item .icon-box i {\r\n\tcolor: #00bcd4;\r\n\tfont-size: 18px;\r\n}\r\n\r\n.contact-info-item .text-info {\r\n\twidth: 80%;\r\n\tfloat: left;\r\n\tmargin-left: 5px;\r\n}\r\n\r\n.contact-info-item .text-info h6 {\r\n\tmargin-bottom: 5px;\r\n}\r\n\r\n.contact-info-item .text-info p {\r\n\tmargin-bottom: 0px;\r\n}\r\n\r\n.contact-info-item a {\r\n\tcolor: #6c757d;\r\n\ttext-decoration: none;\r\n}\r\n\r\n.contact-info-item a:hover {\r\n\tcolor: #00bcd4;\r\n}\r\n\r\n/* map */\r\n.map-box iframe {\r\n\twidth: 100%;\r\n\tborder: 0px;\r\n\theight: 270px;\r\n}\r\n\r\n\r\n\r\n/* Calendrier */\r\n.rbc-calendar {\r\n\tbackground-color: #f8f9fa;\r\n\tborder-radius: 8px;\r\n\tbox-shadow: 0px 4px 10px rgba(0, 0, 0, 0.1);\r\n  }\r\n  \r\n  .rbc-event {\r\n\tbackground-color: #007bff;\r\n\tcolor: white;\r\n\tborder-radius: 4px;\r\n\tpadding: 5px;\r\n  }\r\n  \r\n  .rbc-toolbar button {\r\n\tbackground-color: #007bff;\r\n\tcolor: white;\r\n\tborder-radius: 4px;\r\n  }\r\n  \r\n  .rbc-toolbar button:hover {\r\n\tbackground-color: #0056b3;\r\n  }\r\n  \r\n  .rbc-month-view, .rbc-time-view {\r\n\tborder: none;\r\n  }\r\n\r\n  .rbc-event {\r\n\tfont-size: 12px; /* Ajustez la taille selon vos besoins */\r\n\twhite-space: nowrap; /* Empêche le texte de passer à la ligne */\r\n\toverflow: hidden; /* Masque le débordement */\r\n\ttext-overflow: ellipsis; /* Ajoute des \"...\" pour indiquer qu'il y a plus de texte */\r\n  }\r\n  \r\n\r\n  .faq-container {\r\n\tmax-width: 800px;\r\n\tmargin: 0 auto;\r\n\tpadding: 20px;\r\n\tbackground-color: #f4f6f7; /* Couleur de fond claire pour un contraste agréable */\r\n\tborder-radius: 10px;\r\n  }\r\n  \r\n   /* FAQ */\r\n  .faq-item {\r\n\tmargin-bottom: 15px;\r\n\tborder-radius: 6px;\r\n\tbox-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);\r\n\ttransition: all 0.3s ease-in-out;\r\n  }\r\n  \r\n  .faq-question {\r\n\tbackground-color: #00bcd4;\r\n\tcolor: #fff;\r\n\tpadding: 15px;\r\n\tfont-size: 1.1rem;\r\n\tfont-weight: 600;\r\n\tcursor: pointer;\r\n\tdisplay: flex;\r\n\tjustify-content: space-between;\r\n\talign-items: center;\r\n\tborder-radius: 6px;\r\n\ttransition: background-color 0.3s ease;\r\n  }\r\n  \r\n  .faq-question:hover {\r\n\tbackground-color: #008c9e;\r\n  }\r\n  \r\n  .faq-toggle-icon {\r\n\tfont-size: 1.5rem;\r\n  }\r\n  \r\n  .faq-answer {\r\n\tbackground-color: #e7f5f8;\r\n\tcolor: #333;\r\n\tpadding: 15px;\r\n\tfont-size: 1rem;\r\n\tline-height: 1.6;\r\n\tborder-top: 1px solid #00bcd4;\r\n\tborder-radius: 0 0 6px 6px;\r\n  }\r\n  \r\n  .faq-question.active {\r\n\tbackground-color: #008c9e;\r\n  }\r\n  \r\n  \r\n  \r\n\r\n /* --------------------- Mode nuit --------------------- */\r\n\r\n/* BOUTON DARK MODE */\r\n.theme-switcher-floating {\r\n\tposition: fixed;\r\n\ttop: 2px; /* Décalage du haut */\r\n\tright: 2px; /* Décalage du bord droit */\r\n\tz-index: 9999; /* Pour qu'il soit toujours au-dessus des autres éléments */\r\n\tpadding: 3px;\r\n\tborder-radius: 5px;\r\n  }\r\n  \r\n  .theme-switcher-floating .form-check {\r\n\tmargin-bottom: 0;\r\n  }\r\n  \r\n  @media (max-width: 768px) {\r\n\t.theme-switcher-floating {\r\n\t  top: 2px;\r\n\t  right: 2px;\r\n\t}\r\n  }\r\n  \r\n  @media (min-width: 1200px) {\r\n\t.theme-switcher-floating {\r\n\t  top: 10px;\r\n\t  right: 10px;\r\n\t}\r\n  }\r\n  \r\n\r\n\r\n/* Mode clair */\r\n.light-mode {\r\n\t--background-color: #ffffff;\r\n\t--text-color: #000000;\r\n\t--navbar-text-color: #db1f1f;\r\n  }\r\n  \r\n  /* Mode sombre */\r\n  .dark-mode {\r\n\t--background-color: #555555;\r\n\t--text-color: #ffffff;\r\n\t--navbar-bg-color: #1481ee;\r\n\t--navbar-text-color: #ffffff;\r\n\r\n  }\r\n  \r\n  /* Applique les variables de couleur */\r\n\r\n.dark-mode .no-dark-mode {\r\n    color: #000000 !important; /* Forcer la couleur en noir */\r\n}\r\n\r\n.dark-mode .ConstructionPopUp .no-dark-mode {\r\n    color: #000000 !important; /* Forcer la couleur en noir */\r\n}\r\n  \r\n/* Styles pour l'animation et les cartes personnalisées */\r\n.protocol-card {\r\n\tborder-radius: 10px;\r\n\tcursor: pointer;\r\n\ttransition: transform 0.3s ease;\r\n\tbackground-color: #ffffff;\r\n\tbox-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);\r\n  }\r\n  \r\n  .protocol-card.active {\r\n\ttransform: scale(1.02); /* Agrandir légèrement la carte lorsqu'elle est active */\r\n  }\r\n  \r\n  .protocol-header {\r\n\tbackground: linear-gradient(45deg, #04a0dd, #2575fc);\r\n\tcolor: white;\r\n\tpadding: 20px;\r\n\tborder-bottom: none;\r\n\tborder-radius: 10px 10px 0 0;\r\n  }\r\n  \r\n  .protocol-body {\r\n\tpadding: 20px;\r\n\tdisplay: none;\r\n\tbackground-color: #f9f9f9;\r\n\tborder-radius: 0 0 10px 10px;\r\n\ttransition: max-height 0.4s ease-out;\r\n  }\r\n  \r\n  .protocol-body.show {\r\n\tdisplay: block;\r\n\tanimation: fadeIn 0.4s ease;\r\n  }\r\n  \r\n  /* Animation de fondu pour le contenu */\r\n  @keyframes fadeIn {\r\n\tfrom {\r\n\t  opacity: 0;\r\n\t}\r\n\tto {\r\n\t  opacity: 1;\r\n\t}\r\n  }\r\n  \r\n\r\n  /* Animation pour le fondu de la modale */\r\n.fade-in {\r\n  animation: fadeIn 0.5s ease-in-out;\r\n}\r\n\r\n@keyframes fadeIn {\r\n  from {\r\n    opacity: 0;\r\n  }\r\n  to {\r\n    opacity: 1;\r\n  }\r\n}\r\n\r\n/* Animation pour le zoom de la modale */\r\n.scale-in {\r\n  animation: scaleIn 0.3s ease-in-out;\r\n}\r\n\r\n@keyframes scaleIn {\r\n  from {\r\n    transform: scale(0.7);\r\n  }\r\n  to {\r\n    transform: scale(1);\r\n  }\r\n}\r\n\r\n/* Hover effect for calendar events */\r\n.rbc-event {\r\n  transition: background-color 0.3s ease, transform 0.3s ease;\r\n}\r\n\r\n.rbc-event:hover {\r\n  background-color: #4a90e2 !important;\r\n  transform: translateY(-6px);\r\n}\r\n\r\n/* Animation for menu */\r\n.slide-in-top {\r\n\tanimation: slide-in-top 0.5s ease-out;\r\n  }\r\n  \r\n  @keyframes slide-in-top {\r\n\t0% {\r\n\t  transform: translateY(-100%);\r\n\t  opacity: 0;\r\n\t}\r\n\t100% {\r\n\t  transform: translateY(0);\r\n\t  opacity: 1;\r\n\t}\r\n  }\r\n  \r\n  /* Animation for logo */\r\n  .fade-in {\r\n\tanimation: fade-in 1s ease-in;\r\n  }\r\n  \r\n  @keyframes fade-in {\r\n\t0% {\r\n\t  opacity: 0;\r\n\t}\r\n\t100% {\r\n\t  opacity: 1;\r\n\t}\r\n  }\r\n  \r\n  /* Underline effect on hover */\r\n  .hover-underline:hover {\r\n\ttext-decoration: underline;\r\n\ttransition: text-decoration 0.3s ease;\r\n  }\r\n  \r\n  /* Custom styling for dropdown */\r\n  .dropdown-menu {\r\n\tborder-radius: 8px;\r\n\tbox-shadow: 0 8px 16px rgba(0, 0, 0, 0.1);\r\n  }\r\n  \r\n  .blog-card {\r\n\ttransition: transform 0.3s ease, box-shadow 0.3s ease;\r\n  }\r\n  \r\n  .blog-card:hover {\r\n\ttransform: translateY(-10px);\r\n\tbox-shadow: 0 8px 16px rgba(0, 0, 0, 0.2);\r\n  }\r\n  \r\n  .text-truncate-3 {\r\n\tdisplay: -webkit-box;\r\n\t-webkit-line-clamp: 3;\r\n\t-webkit-box-orient: vertical;\r\n\toverflow: hidden;\r\n\ttext-overflow: ellipsis;\r\n  }\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
